<template>
    <div class="redaccion-tool-component">
        <div v-if="is_new_conversation" class="tool-header">
            <h2>Redacción</h2>
            <div v-if="localSelectedOption !== ''" class="tool-header-title">
                <h3>Crear {{ localSelectedOption }}</h3>
            </div>
            <div class="tool-mode-selector">
                MODO: &nbsp;
                <select v-model="localSelectedOption">
                    <option disabled value="">Seleccione una opción</option>
                    <option v-for="option in modosOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="localSelectedOption === 'Nota' && !is_new_conversation && notaSummary" class="tool-header tabs">
            <h2 @click="selectTab('INPUT')" :class="{ 'tab-button': true, 'selected': INPUT_SELECTED }">INPUT</h2>
            <h2 @click="selectTab('OUTPUT')" :class="{ 'tab-button': true, 'selected': OUTPUT_SELECTED }">OUTPUT</h2>
            <h2 @click="selectTab('PASOS INTERMEDIOS')"
                :class="{ 'tab-button': true, 'selected': INTERMEDIATE_STEPS_SELECTED }">PASOS INTERMEDIOS</h2>
            <h2 @click="selectTab('ERRORS')" :class="{ 'tab-button': true, 'selected': ERRORS_SELECTED }">ERRORS ({{
                errors?.length }})</h2>
            <h2 v-if="notaSummary?.status === 'failed'" @click="retryComposeArticle" class="retry-button">
                <button>Reintentar</button>
            </h2>
        </div>

        <div v-if="localSelectedOption === '' && is_new_conversation" class="option-container">
            <!-- For each modosOptions display a button with that label and onclick setModo to value -->
            <h6 class="hint">{{ modosHint }}</h6>
            <div class="modo-options">
                <button v-for="option in modosOptions" :key="option.value" @click="localSelectedOption = option.value"
                    @mouseover="modosHint = option.hint">
                    <ion-icon :name="option.icon"></ion-icon>
                    {{ option.label }}
                </button>
            </div>
        </div>

        <div v-if="localSelectedOption === 'Nota' && is_new_conversation" class="option-container modo-nota">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}: <span>{{ selectedStepName }}</span></h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in steps" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <button v-if="activeStep === 5 && !articleCreated" class="primary"
                        @click="createArticle">Crear</button>
                    <button @click="previousStep"><ion-icon name="arrow-back"></ion-icon> Anterior</button>
                    <button @click="nextStep">Siguiente <ion-icon name="arrow-forward"></ion-icon></button>
                </div>
            </div>
            <div v-show="activeStep === 0 || activeStep === 5" class="instrucciones-generales">
                <div class="column">
                    <h3>Instrucciones Generales:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon>
                        Describir el propósito general del artículo, qué tipo de nota es y su objetivo. Mientras más
                        detalles sobre la longitud del texto, su estilo, su propósito y la línea política que le
                        queremos imprimir, mejor.</h6>
                </div>
                <textarea v-model="instruccionesGenerales" name="instrucciones-generales" id="instrucciones-generales"
                    cols="20" rows="10"></textarea>
            </div>
            <div v-show="showForm && (activeStep === 1 || activeStep === 5)" class="fuentes-externas">





                <div class="urls-fuentes-externas">
                    <h3>Fuentes Externas:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon>
                        Para incorporar información de otros portales de noticias o de cualquier web, ingresar acá la/s
                        URL/s de las cuales se quiere extraer información. Tener en cuenta que no todas las notas pueden
                        ser descargadas para su uso. Para comprobar si está accesible, se puede seleccionar el modo
                        "Probar descargar nota" en el menú de la esquina superior derecha, y verificar ahí si se puede
                        obtener el cuerpo de la nota.</h6>

                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="notaComplejaDesdeLinks"
                            :callback="value => notaComplejaDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="notaComplejaDesdeTextos"
                            :callback="value => notaComplejaDesdeTextos = value" />
                    </div>
                    <div style="border-bottom: 1px solid #fff;" class="fuentes-externas-list"
                        v-if="notaComplejaDesdeLinks">
                        <h3>Links:</h3>

                        <div class="fuentes-externas-row" v-for="(source, index) in sources" :key="index">
                            <label for="source">Fuente {{ index + 1 }}</label>
                            <input type="text" v-model="sources[index]" placeholder="Ingrese URL">
                            <button v-if="index === sources.length - 1" @click="addSource">Agregar otra +</button>
                            <button v-if="index === sources.length - 1 && sources.length > 1"
                                @click="removeSource">Sacar
                                una</button>
                        </div>
                    </div>
                    <div class="fuentes-externas-list" v-if="notaComplejaDesdeTextos">
                        <h3>Textos:</h3>
                        <div class="fuentes-externas-row" v-for="(source, index) in sourcesTexts" :key="index">
                            <label for="source">Fuente {{ index + 1 }}</label>
                            <textarea type="text" v-model="sourcesTexts[index]" placeholder="Pegar texto"></textarea>
                            <button v-if="index === sourcesTexts.length - 1" @click="addSourceText">Agregar otra
                                +</button>
                            <button v-if="index === sourcesTexts.length - 1 && sourcesTexts.length > 1"
                                @click="removeSourceText">Sacar
                                una</button>
                        </div>
                    </div>
                </div>


                <!-- <template v-if="notaComplejaDesdeLinks">
                    <h3>Links base para editorializar:</h3>
                    <div v-for="(link, index) in editorialLinks" :key="index" class="reinterpretar-link-row">
                        <div class="row">
                            <label>link {{ index + 1 }})</label>
                            <input type="text" v-model="editorialLinks[index]" placeholder="Ingrese URL">
                            <button v-if="index === editorialLinks.length - 1" @click="addEditorialLink">Agregar
                                otra +</button>
                            <button v-if="index === editorialLinks.length - 1 && editorialLinks.length > 1"
                                @click="removeEditorialLink">Sacar una</button>
                        </div>
                    </div>
                </template> -->
                <div class="instrucciones-fuentes-externas">
                    <h3>Instrucciones Fuentes Externas:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon>
                        ¿Qué de todo el contenido del link provisto en el lado izquierdo debería ser tomado en cuenta
                        para la redacción del artículo?
                        <p>Intentar especificar si nos interesa la información objetiva, los hechos descritos, la linea
                            política del artículo, etc.</p><br /><br /><br /><br /><br /><br />
                    </h6>
                    <div style="margin-bottom: 24px;" class="instrucciones-fuentes-externas-list"
                        v-if="notaComplejaDesdeLinks">
                        <div class="fuentes-externas-row" v-for="(source, index) in sources" :key="index">
                            <label for="source">Instrucciones link {{ index + 1 }}:</label>
                            <input type="text" v-model="sourcesInstructions[index]" placeholder="Ingrese instrucciones">
                        </div>
                    </div>
                    <br /><br />
                    <div class="instrucciones-fuentes-externas-list" v-if="notaComplejaDesdeTextos">
                        <div class="fuentes-externas-row" v-for="(source, index) in sourcesTexts" :key="index">
                            <label for="source">Instrucciones texto {{ index + 1 }}:</label>
                            <input type="text" v-model="sourcesTextsInstructions[index]"
                                placeholder="Ingrese instrucciones">
                        </div>
                    </div>
                </div>
            </div>
            <!-- -->
            <!-- -->
            <div v-show="showForm && (activeStep === 2 || activeStep === 5)" class="fuentes-archivos">
                <div class="urls-fuentes-archivos">
                    <h3>Utilizar información de archivos:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon> Si se desea que el artículo creado tenga
                        información de algún archivo (por ejemplo un informe, un estudio publicado, o cualquier otro
                        documento), se pueden adjuntar archivos en formato PDF que contengan texto.<br /></h6>
                    <div class="fuentes-archivos-list">
                        <div class="fuentes-archivos-row" v-for="(file, index) in fileSources" :key="index">
                            <label>Archivo:</label>
                            <input type="file" @change="onFileChange($event, index)" accept="application/pdf">
                            <!-- Display the selected file name -->
                            <span>{{ file.name }}</span>
                            <button v-if="index === fileSources.length - 1" @click="addFileSource">Agregar otro
                                +</button>
                            <button v-if="index === fileSources.length - 1 && fileSources.length > 1"
                                @click="removeFileSource">Quitar
                                uno</button>
                        </div>
                    </div>
                </div>
                <div class="instrucciones-fuentes-archivos">
                    <h3>Instrucciones para sacar información de cada archivo:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon>
                        ¿Qué de todo el contenido del link provisto en el lado izquierdo debería ser tomado en cuenta
                        para la redacción del artículo?
                        <p>Intentar especificar si nos interesa la información objetiva, los hechos descritos, la linea
                            política del artículo, etc.</p>
                    </h6>
                    <div class="instrucciones-fuentes-archivos-list">
                        <div class="fuentes-archivos-row" v-for="(source, index) in fileSources" :key="index">
                            <label for="source">Instrucciones específicas archivo {{ index + 1 }}</label>
                            <input type="text" v-model="fileSourcesInstructions[index]"
                                placeholder="Ingrese instrucciones">
                        </div>
                    </div>
                </div>
            </div>
            <!-- -->
            <!-- -->
            <div v-show="showForm && (activeStep === 3 || activeStep === 5)" class="fuentes-propias">
                <h3>Usar información de LID a través de ChatPTS:</h3>
                <h6><ion-icon name="information-circle"></ion-icon>
                    Acá se puede ingresar una o más preguntas para hacerle a ChatPTS, que utilizará información de LID,
                    CEIP, PTS, IPS para intentar formular una respuesta a lo que aquí se pida. Luego, juntando esa
                    información con las demás fuentes provistas, se intentará elaborar el artículo.
                </h6>
                <div class="otras-opciones-row no-shrink">
                    <label for="otras-opciones">Usar información de notas previas:</label>
                    <SwitchComponent :value="usarNotasPrevias" :callback="value => usarNotasPrevias = value" />
                </div>
                <div v-if="usarNotasPrevias" class="row">
                    <div class="otras-opciones-row no-shrink">
                        <label for="otras-opciones">Preguntas a ChatPTS:</label>
                        <SwitchComponent :value="usarPreguntasChatPTS"
                            :callback="value => usarPreguntasChatPTS = value" />
                    </div>
                    <div v-if="usarPreguntasChatPTS" class="otras-opciones-row">
                        <label for="otras-opciones">Preguntas para hacerle al chat:</label>
                        <div v-for="(instruccion, index) in instruccionesNotasPrevias" :key="index">
                            <input type="text" v-model="instruccionesNotasPrevias[index]"
                                placeholder="Ingrese instrucciones">
                        </div>
                        <button @click="addInstruccionNotaPrevia">Agregar otra +</button>
                        <button v-if="instruccionesNotasPrevias.length > 1" @click="removeInstruccionNotaPrevia">Sacar
                            una</button>
                    </div>
                </div>
                <div v-if="usarNotasPrevias" class="row">
                    <div class="otras-opciones-row no-shrink">
                        <label for="otras-opciones">Buscar notas de LID específicas:</label>
                        <SwitchComponent :value="usarNotasDeLID" :callback="value => usarNotasDeLID = value" />
                    </div>
                    <div v-if="usarNotasDeLID" class="otras-opciones-row">
                        <label for="otras-opciones">Buscar:</label>
                        <input type="text" v-model="queryBuscarEnLID" placeholder="Ingresar palabra o frase"
                            @keyup.enter="buscarEnLid">
                        <button @click="buscarEnLid">Buscar en LID</button>
                    </div>
                </div>
                <div v-if="loadingResultadosBusquedaLid">Cargando...</div>
                <div v-if="usarNotasDeLID && resultadosBusquedaLid && !loadingResultadosBusquedaLid">
                    <h2>Resultados de búsqueda: </h2>
                    <ResultadosBusquedaLID :results="resultadosBusquedaLid" @select-lid-result="addSelectedResult"
                        @deselect-lid-result="removeSelectedResult" />
                </div>
                <div v-if="usarNotasDeLID && resultadosBusquedaLidSeleccionados">
                    <h2>Notas a usar:</h2>
                    <ResultadosBusquedaLID :results="resultadosBusquedaLidSeleccionados" :is-selected-results="true"
                        @select-lid-result="addSelectedResult" @deselect-lid-result="removeSelectedResult"
                        @update-lid-instructions="updateLidInstructions" />
                </div>
            </div>
            <div v-show="showForm && (activeStep === 4 || activeStep === 5)" class="otras-opciones">
                <div class="column">
                    <h3>Otras opciones:</h3>
                    <h6><ion-icon name="information-circle"></ion-icon>
                        Proponer varios títulos: Si se selecciona esta opción, se debe ingresar instrucciones para
                        generar
                        además del título principal, 3 variantes de títulos para el artículo principal.
                        <br />
                        <br />
                        <ion-icon name="information-circle"></ion-icon>
                        Intentar copiar estilo de: Si se desea que el artículo creado tenga un estilo de escritura
                        similar
                        al de una nota en particular, se puede ingresar la URL de la nota de la cual se quiere copiar el
                        estilo. Puede ser una nota de LID o de otro medio.
                    </h6>
                </div>
                <div class="otras-opciones-list">
                    <div class="row">
                        <div class="otras-opciones-row">
                            <label for="otras-opciones">Proponer varios títulos:</label>
                            <SwitchComponent :value="incluirTitulos" :callback="value => incluirTitulos = value" />
                        </div>
                        <div v-if="incluirTitulos" class="otras-opciones-row">
                            <label for="otras-opciones">Instrucciones para los títulos:</label>
                            <input type="url" v-model="instruccionesTitulos">
                        </div>
                    </div>
                    <div class="otras-opciones-row">
                        <label for="otras-opciones">Intentar copiar estilo de:</label>
                        <input type="url" v-model="sacarEstilosDeUrl">
                    </div>
                </div>
            </div>
            <div class="row">
                <button v-if="activeStep === 5 && !articleCreated" class="primary" @click="createArticle">Crear</button>
                <div class="after-created" v-if="articleCreated">
                    <button class="secondary" @click="toggleForm">{{ showForm ? 'Ver menos' : 'Ver más' }}</button>
                    <div class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="localSelectedOption === 'Reinterpretar'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>
                    <button v-if="!reinterpretarCreado && activeStep === 2" :disabled="reinterpretarLoading"
                        class="primary" @click="createReinterpretar">{{
                            !reinterpretarLoading ? 'Reinterpretar todos' :
                                'Reinterpretando...' }}</button>
                    <button v-if="reinterpretarCreado && activeStep === 3" :disabled="reinterpretarLoading"
                        class="primary" @click="retryReinterpretarCreado">{{
                            !reinterpretarLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">
                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes que
                            queremos
                            reinterpretar.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="reinterpretarDesdeLink"
                            :callback="value => reinterpretarDesdeLink = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="reinterpretarDesdeTexto"
                            :callback="value => reinterpretarDesdeTexto = value" />
                    </div>

                    <template v-if="reinterpretarDesdeLink">
                        <h3>Links para reinterpretar:</h3>
                        <div v-for="(link, index) in reinterpretarLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <label>link {{ index + 1 }})</label>
                                <input type="text" v-model="reinterpretarLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === reinterpretarLinks.length - 1"
                                    @click="addReinterpretarLink">Agregar
                                    otra +</button>
                                <button v-if="index === reinterpretarLinks.length - 1 && reinterpretarLinks.length > 1"
                                    @click="removeReinterpretarLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="reinterpretarDesdeTexto">
                        <h3>Textos para reinterpretar:</h3>
                        <div v-for="(texto, index) in reinterpretarTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <label>texto {{ index + 1 }})</label>
                                <textarea v-model="reinterpretarTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === reinterpretarTextos.length - 1"
                                    @click="addReinterpretarTexto">Agregar
                                    otra
                                    +</button>
                                <button
                                    v-if="index === reinterpretarTextos.length - 1 && reinterpretarTextos.length > 1"
                                    @click="removeReinterpretarTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las instrucciones
                            sobre
                            como
                            reinterpretar las fuentes del paso anterior.</h6>
                        <h6>Para cada una de las fuentes (cada link o cada texto pegado), se puede especificar una
                            instrucción distinta.
                        </h6>
                        <h6>Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la duda
                            se
                            puede dejar
                            como está.</h6>
                    </div>
                    <template v-if="reinterpretarDesdeLink">
                        <h3>Instrucciones para reinterpretar links:</h3>
                        <div v-for="(link, index) in reinterpretarLinks" :key="index" class="reinterpretar-link-row">
                            <label>link {{ index + 1 }}) {{ link?.substring(0, 100) }}...</label>
                            <div class="row">
                                <textarea v-model="reinterpretarLinksInstrucciones[index]"
                                    placeholder="Ingrese instrucciones"></textarea>
                            </div>
                        </div>
                    </template>

                    <template v-if="reinterpretarDesdeTexto">
                        <h3>Instrucciones para reinterpretar textos:</h3>
                        <div v-for="(texto, index) in reinterpretarTextos" :key="index" class="reinterpretar-texto-row">
                            <label>texto {{ index + 1 }}) {{ texto?.substring(0, 100) }}...</label>
                            <div class="row">
                                <textarea v-model="reinterpretarTextosInstrucciones[index]"
                                    placeholder="Ingrese instrucciones"></textarea>
                            </div>
                        </div>
                    </template>


                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!reinterpretarCreado">Acá aparecerán los resultados</h3>
                    <div v-if="reinterpretarCreado" class="resultados">
                        <h3>Resultados de links:</h3>
                        <div v-for="(resultado, index) in reinterpretarLinkResults" :key="index" class="resultado">
                            <label>link {{ index + 1 }}) {{ link?.substring(0, 100) }}...</label>
                            <textarea :value="resultado"></textarea>
                        </div>
                    </div>
                    <div v-if="reinterpretarCreado" class="resultados">
                        <h3>Resultados de textos:</h3>
                        <div v-for="(resultado, index) in reinterpretarTextsResults" :key="index" class="resultado">
                            <label>texto {{ index + 1 }}) {{ texto?.substring(0, 100) }}...</label>
                            <textarea :value="resultado"></textarea>
                        </div>
                    </div>
                    <div v-if="reinterpretarCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="reinterpretarCreado" v-show="activeStep !== 3" class="col-errors cerrada"
                    @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="reinterpretarCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>
            </div>
        </div>

        <div v-if="localSelectedOption === 'Editorial'" class=" option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>
                    <button v-if="!editorialCreado && activeStep == 2" :disabled="editorialLoading" class="primary"
                        @click="createEditorial">{{
                            !editorialLoading ? 'Crear nota con editorial' :
                                'Creando...' }}</button>
                    <button v-if="editorialCreado && activeStep == 3" :disabled="editorialLoading" class="primary"
                        @click="retryEditorialCreado">{{
                            !editorialLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">
                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes que
                            queremos
                            editorializar.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los artículos y textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver un solo
                            resultado con
                            todas las fuentes unidas.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="editorialDesdeLinks"
                            :callback="value => editorialDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="editorialDesdeTextos"
                            :callback="value => editorialDesdeTextos = value" />
                    </div>

                    <template v-if="editorialDesdeLinks">
                        <h3>Links base para editorializar:</h3>
                        <div v-for="(link, index) in editorialLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <label>link {{ index + 1 }})</label>
                                <input type="text" v-model="editorialLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === editorialLinks.length - 1" @click="addEditorialLink">Agregar
                                    otra +</button>
                                <button v-if="index === editorialLinks.length - 1 && editorialLinks.length > 1"
                                    @click="removeEditorialLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="editorialDesdeTextos">
                        <h3>Textos base para editorializar:</h3>
                        <div v-for="(texto, index) in editorialTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <label>texto {{ index + 1 }})</label>
                                <textarea v-model="editorialTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === editorialTextos.length - 1" @click="addEditorialTexto">Agregar
                                    otra
                                    +</button>
                                <button v-if="index === editorialTextos.length - 1 && editorialTextos.length > 1"
                                    @click="removeEditorialTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>

                    <h3>Instrucciones generales para el artículo:</h3>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> Acá determinamos las características y el
                            objetivo
                            general del artículo (del resultado que queremos obtener).</h6>
                        <h6>Como siempre, más especificidad e información ayuda.</h6>
                    </div>
                    <textarea v-model="editorialGeneralInstructions" class="general-instructions"></textarea>

                    <h3>Linea editorial:</h3>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> Las fuentes (sean links o textos) deben
                            contener
                            los
                            hechos periodísticos sobre los que queremos editorializar.</h6>
                        <h6>Luego hay dos formas de sumarle la parte editorial (la línea política) a eso: se puede hacer
                            que
                            la IA
                            detecte automáticamente el tema central del artículo que queremos escribir.</h6>
                        <h6>O se pueden agregar uno o más links de los que queremos extraer la editorial.</h6>
                    </div>
                    <div class="row">
                        <label>Buscar linea editorial del tema automáticamente en ChatPTS:</label>
                        <SwitchComponent :value="editorialLineaDesdeChatPTS"
                            :callback="value => editorialLineaDesdeChatPTS = value" />
                    </div>
                    <div class="row">
                        <label>Buscar linea editorial en un link específico:</label>
                        <SwitchComponent :value="editorialLineaDesdeLinks"
                            :callback="value => editorialLineaDesdeLinks = value" />
                    </div>
                    <template v-if="editorialLineaDesdeLinks">
                        <h3>Links linea editorial:</h3>
                        <div v-for="(link, index) in editorialLineaLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <input type="text" v-model="editorialLineaLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === editorialLineaLinks.length - 1"
                                    @click="addEditorialLineaLink">Agregar
                                    otra +</button>
                                <button
                                    v-if="index === editorialLineaLinks.length - 1 && editorialLineaLinks.length > 1"
                                    @click="removeEditorialLineaLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="editorialDesdeLinks">
                        <h3>Instrucciones para extraer info de los links:</h3>
                        <div v-for="(link, index) in editorialLinks" :key="index" class="reinterpretar-link-row">
                            <label>link {{ index + 1 }}) {{ link?.substring(0, 100) }}...</label>
                            <div class="row">
                                <input type="text" v-model="editorialLinksInstructions[index]"
                                    placeholder="Ingrese instrucciones">
                            </div>
                        </div>
                    </template>

                    <template v-if="editorialDesdeTextos">
                        <h3>Instrucciones para extraer info de los textos:</h3>
                        <div v-for="(texto, index) in editorialTextos" :key="index" class="reinterpretar-texto-row">
                            <label>texto {{ index + 1 }}) {{ texto?.substring(0, 100) }}...</label>
                            <div class="row">
                                <textarea v-model="editorialTextosInstructions[index]"
                                    placeholder="Ingrese instrucciones"></textarea>
                            </div>
                        </div>
                    </template>


                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!editorialCreado">Acá aparecerán los resultados</h3>
                    <div v-if="editorialCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Título</h4>
                        <textarea v-show="editorialResult" :value="editorialResult?.title"></textarea>
                        <h4>Resumen / bajada</h4>
                        <textarea v-show="editorialResult" :value="editorialResult?.summary"></textarea>
                        <h4>Cuerpo</h4>
                        <textarea v-show="editorialResult" :value="editorialResult?.body"></textarea>
                    </div>
                    <div v-if="editorialCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="editorialCreado" v-show="activeStep !== 3" class="col-errors cerrada"
                    @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="editorialCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>




            </div>
        </div>

        <div v-if="localSelectedOption === 'Placas'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>

                    <button v-if="!placasCreado && activeStep == 2" :disabled="placasLoading" class="primary"
                        @click="createPlacas">{{
                            !placasLoading ? 'Crear placas' :
                                'Creando...' }}</button>
                    <button v-if="placasCreado && activeStep == 3" :disabled="placasLoading" class="primary"
                        @click="retryPlacasCreado">{{
                            !placasLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">
                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes a partir
                            de
                            las
                            cuales queremos crear placas de Instagram o similar.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los artículos y textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver un solo
                            resultado con
                            todas las fuentes unidas.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="placasDesdeLinks" :callback="value => placasDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="placasDesdeTextos" :callback="value => placasDesdeTextos = value" />
                    </div>

                    <template v-if="placasDesdeLinks">
                        <h3>Links fuente:</h3>
                        <div v-for="(link, index) in placasLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <input type="text" v-model="placasLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === placasLinks.length - 1" @click="addPlacaLink">Agregar
                                    otra +</button>
                                <button v-if="index === placasLinks.length - 1 && placasLinks.length > 1"
                                    @click="removePlacaLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="placasDesdeTextos">
                        <h3>Textos fuente:</h3>
                        <div v-for="(texto, index) in placasTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <textarea v-model="placasTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === placasTextos.length - 1" @click="addPlacaTexto">Agregar otra
                                    +</button>
                                <button v-if="index === placasTextos.length - 1 && placasTextos.length > 1"
                                    @click="removePlacaTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon>
                            Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la duda
                            se
                            puede dejar
                            como está.</h6>
                    </div>
                    <template v-if="placasDesdeLinks || placasDesdeTextos">
                        <h3>Instrucciones para crear las placas a partir de las fuentes:</h3>
                        <textarea class="placas-general-prompt" v-model="placasGeneralInstructions"></textarea>
                    </template>

                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!placasCreado">Acá aparecerán los resultados</h3>
                    <div v-if="placasCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Placas</h4>
                        <textarea v-show="placasResult" v-model="placasResult"></textarea>
                    </div>
                    <div v-if="placasCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="placasCreado" v-show="activeStep !== 3" class="col-errors cerrada" @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="placasCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>


            </div>

        </div>

        <div v-if="localSelectedOption === 'Twitter'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>

                    <button v-if="!twitterCreado && activeStep == 2" :disabled="twitterLoading" class="primary"
                        @click="createTwitter">{{
                            !twitterLoading ? 'Crear twitter' :
                                'Creando...' }}</button>
                    <button v-if="twitterCreado && activeStep == 3" :disabled="twitterLoading" class="primary"
                        @click="retryTwitterCreado">{{
                            !twitterLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">

                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes a partir
                            de
                            las
                            cuales queremos crear el hilo de X (Twitter) o similar.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los artículos y textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver un solo
                            resultado con
                            todas las fuentes unidas.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="twitterDesdeLinks" :callback="value => twitterDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="twitterDesdeTextos" :callback="value => twitterDesdeTextos = value" />
                    </div>

                    <template v-if="twitterDesdeLinks">
                        <h3>Links fuente:</h3>
                        <div v-for="(link, index) in twitterLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <input type="text" v-model="twitterLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === twitterLinks.length - 1" @click="addTwitterLink">Agregar
                                    otra +</button>
                                <button v-if="index === twitterLinks.length - 1 && twitterLinks.length > 1"
                                    @click="removeTwitterLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="twitterDesdeTextos">
                        <h3>Textos fuente:</h3>
                        <div v-for="(texto, index) in twitterTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <textarea v-model="twitterTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === twitterTextos.length - 1" @click="addTwitterTexto">Agregar otra
                                    +</button>
                                <button v-if="index === twitterTextos.length - 1 && twitterTextos.length > 1"
                                    @click="removeTwitterTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon>
                            Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la duda
                            se
                            puede dejar
                            como está.</h6>
                    </div>
                    <template v-if="twitterDesdeLinks || twitterDesdeTextos">
                        <h3>Instrucciones para crear el hilo a partir de las fuentes:</h3>
                        <textarea class="placas-general-prompt" v-model="twitterGeneralInstructions"></textarea>
                    </template>
                    <br />
                    <br />
                    <div class="row">
                        <label for="presentAuthorSwitch">Presentar al autor</label>
                        <SwitchComponent :value="presentAuthor" :callback="newValue => presentAuthor = newValue"
                            id="presentAuthorSwitch" />
                    </div>
                    <div class="row">
                        <label for="minTwits">Número mínimo de twits</label>
                        <input type="number" v-model.number="minNumberOfTwits" id="minTwits" min="1" max="50" />
                    </div>
                    <div class="row">
                        <label for="maxTwits">Número máximo de twits</label>
                        <input type="number" v-model.number="maxNumberOfTwits" id="maxTwits" min="1" max="50" />
                    </div>

                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!twitterCreado">Acá aparecerán los resultados</h3>
                    <div v-if="twitterCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Hilo</h4>
                        <textarea v-show="twitterResult" v-model="twitterResult"></textarea>
                    </div>
                    <div v-if="twitterCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="twitterCreado" v-show="activeStep !== 3" class="col-errors cerrada" @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="twitterCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>


            </div>
        </div>

        <div v-if="localSelectedOption === 'Guion'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>

                    <button v-if="!guionCreado && activeStep == 2" :disabled="guionLoading" class="primary"
                        @click="createGuion">{{
                            !guionLoading ? 'Crear guion' :
                                'Creando...' }}</button>
                    <button v-if="guionCreado && activeStep == 3" :disabled="guionLoading" class="primary"
                        @click="retryGuionCreado">{{
                            !guionLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">
                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes a partir
                            de
                            las
                            cuales queremos crear el guion.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los artículos y textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver un solo
                            resultado con
                            todas las fuentes unidas.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="guionDesdeLinks" :callback="value => guionDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="guionDesdeTextos" :callback="value => guionDesdeTextos = value" />
                    </div>

                    <template v-if="guionDesdeLinks">
                        <h3>Links fuente:</h3>
                        <div v-for="(link, index) in guionLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <input type="text" v-model="guionLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === guionLinks.length - 1" @click="addGuionLink">Agregar
                                    otra +</button>
                                <button v-if="index === guionLinks.length - 1 && guionLinks.length > 1"
                                    @click="removeGuionLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="guionDesdeTextos">
                        <h3>Textos fuente:</h3>
                        <div v-for="(texto, index) in guionTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <textarea v-model="guionTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === guionTextos.length - 1" @click="addGuionTexto">Agregar otra
                                    +</button>
                                <button v-if="index === guionTextos.length - 1 && guionTextos.length > 1"
                                    @click="removeGuionTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon>
                            Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la duda
                            se
                            puede dejar
                            como está.</h6>
                        <h6>Algunas cosas que se pueden especificar: qué de la política queremos resaltar, cuántas
                            personas
                            deberían
                            aparecer en el video, duración aproximada, tono general, a quién va dirigido, etc.</h6>
                    </div>
                    <template v-if="guionDesdeLinks || guionDesdeTextos">
                        <h3>Instrucciones para crear el guion a partir de las fuentes:</h3>
                        <textarea class="placas-general-prompt" v-model="guionGeneralInstructions"></textarea>
                    </template>

                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!guionCreado">Acá aparecerán los resultados</h3>
                    <div v-if="guionCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Guion</h4>
                        <textarea v-show="guionResult" v-model="guionResult"></textarea>
                    </div>
                    <div v-if="guionCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="guionCreado" v-show="activeStep !== 3" class="col-errors cerrada" @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="guionCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>


            </div>
        </div>

        <div v-if="localSelectedOption === 'Corrector'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>

                    <button v-if="!correctionCreado && activeStep == 2" :disabled="correctionLoading" class="primary"
                        @click="createCorrection">{{
                            !correctionLoading ? 'Corregir texto' :
                                'Corrigiendo...' }}</button>
                    <button v-if="correctionCreado && activeStep == 3" :disabled="correctionLoading" class="primary"
                        @click="retryCorrectionCreado">{{
                            !correctionLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">
                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes a que
                            queremos
                            corregir.</h6>
                        <h6>Las fuentes pueden ser uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver un solo
                            resultado con
                            todas las fuentes unidas.</h6>
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="correctionDesdeTextos"
                            :callback="value => correctionDesdeTextos = value" />
                    </div>

                    <template v-if="correctionDesdeTextos">
                        <h3>Textos fuente:</h3>
                        <div v-for="(texto, index) in correctionTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <textarea v-model="correctionTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === correctionTextos.length - 1" @click="addCorrectionTexto">Agregar
                                    otra
                                    +</button>
                                <button v-if="index === correctionTextos.length - 1 && correctionTextos.length > 1"
                                    @click="removeCorrectionTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon>
                            Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la duda
                            se
                            puede dejar
                            como está.</h6>
                        <h6>Algunas cosas que se pueden especificar: qué de la política queremos resaltar, cuántas
                            personas
                            deberían
                            aparecer en el video, duración aproximada, tono general, a quién va dirigido, etc.</h6>
                    </div>
                    <template v-if="correctionDesdeLinks || correctionDesdeTextos">
                        <h3>Instrucciones para corregir el texto de las fuentes:</h3>
                        <textarea class="placas-general-prompt" v-model="correctionGeneralInstructions"></textarea>
                    </template>

                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!correctionCreado">Acá aparecerán los resultados</h3>
                    <div v-if="correctionCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Texto corregido:</h4>
                        <textarea v-show="correctionResult" v-model="correctionResult"></textarea>
                    </div>
                    <div v-if="correctionCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="correctionCreado" v-show="activeStep !== 3" class="col-errors cerrada"
                    @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="correctionCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>


            </div>
        </div>





        <div v-if="localSelectedOption === 'Títulos'" class="option-container modo-reinterpretar">
            <div class="slider-controls">
                <h2>Paso {{ activeStep + 1 }}</h2>
                <div class="slide-indicator">
                    <div v-for="(step, index) in [1, 2, 3]" :key="index" class="indicator"
                        :class="{ 'active': index === activeStep }"></div>
                </div>
                <div class="slider-buttons">
                    <!-- <div class="buttons-carrusel"> -->
                    <button class="secondary" @click="activeStep = activeStep - 1"
                        v-show="activeStep > 0">Anterior</button>
                    <button class="primary" @click="activeStep = activeStep + 1"
                        v-show="activeStep < 2">Siguiente</button>

                    <button v-if="!titulosCreado && activeStep == 2" :disabled="titulosLoading" class="primary"
                        @click="createTitulos">{{
                            !titulosLoading ? 'Crear títulos' :
                                'Creando...' }}</button>
                    <button v-if="titulosCreado && activeStep == 3" :disabled="titulosLoading" class="primary"
                        @click="retryTitulosCreado">{{
                            !titulosLoading ? 'Reintentar' :
                                'Reintentando...' }}</button>
                    <!-- </div> -->
                </div>
            </div>
            <div class="cols">

                <div class="col-izq cerrada" v-show="activeStep !== 0" @click="activeStep = 0">
                    <h2>1. Fuentes</h2>
                </div>
                <div class="col-izq" v-show="activeStep === 0">
                    <h2>1. Fuentes</h2>
                    <div class="row row-h6">
                        <h6><ion-icon name="information-circle"></ion-icon> En este paso agregamos las fuentes a partir
                            de
                            las
                            cuales queremos crear títulos y bajada.</h6>
                        <h6>Las fuentes pueden ser uno o más links (se intentará obtener el contenido de cada link en
                            cada
                            caso) ó uno o más textos pegados.</h6>
                        <h6>La IA va a intentar combinar el contenido de todos los artículos y textos pegados que se
                            proporcionen
                            (según las instrucciones que se le proveen en el paso siguiente) y va a devolver una
                            propuesta
                            de bajada
                            y varias propuestas de títulos alrededor de todo el contenido combinado.</h6>
                    </div>
                    <div class="row">
                        <label>Agregar links:</label>
                        <SwitchComponent :value="titulosDesdeLinks" :callback="value => titulosDesdeLinks = value" />
                    </div>
                    <div class="row">
                        <label>Pegar textos:</label>
                        <SwitchComponent :value="titulosDesdeTextos" :callback="value => titulosDesdeTextos = value" />
                    </div>

                    <template v-if="titulosDesdeLinks">
                        <h3>Links fuente:</h3>
                        <div v-for="(link, index) in titulosLinks" :key="index" class="reinterpretar-link-row">
                            <div class="row">
                                <input type="text" v-model="titulosLinks[index]" placeholder="Ingrese URL">
                                <button v-if="index === titulosLinks.length - 1" @click="addTitulosLink">Agregar
                                    otra +</button>
                                <button v-if="index === titulosLinks.length - 1 && titulosLinks.length > 1"
                                    @click="removeTitulosLink">Sacar una</button>
                            </div>
                        </div>
                    </template>

                    <template v-if="titulosDesdeTextos">
                        <h3>Textos fuente:</h3>
                        <div v-for="(texto, index) in titulosTextos" :key="index" class="reinterpretar-texto-row">
                            <div class="row">
                                <textarea v-model="titulosTextos[index]" placeholder="Ingrese texto"></textarea>
                                <button v-if="index === titulosTextos.length - 1" @click="addTitulosTexto">Agregar otra
                                    +</button>
                                <button v-if="index === titulosTextos.length - 1 && titulosTextos.length > 1"
                                    @click="removeTitulosTexto">Sacar una</button>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-med cerrada" v-show="activeStep !== 1" @click="activeStep = 1">
                    <h2>2. Instrucciones</h2>
                </div>
                <div class="col-med" v-show="activeStep === 1">
                    <h2>2. Instrucciones</h2>
                    <div class="row">
                        <label>Número de títulos a proponer: </label>
                        <input type="number" v-model="titulosCantidad" />
                    </div>

                    <template v-if="titulosDesdeLinks || titulosDesdeTextos">
                        <h3>Instrucciones para crear las títulos a partir de las fuentes:</h3>
                        <div class="row row-h6">
                            <h6><ion-icon name="information-circle"></ion-icon>
                                Mientras más detalle de lo que queremos y para qué lo vamos a usar, mejor. Pero ante la
                                duda
                                se
                                puede dejar
                                como está.</h6>
                            <h6>Algunas cosas que se pueden especificar e intentará respetar: mayor o menor creatividad,
                                mayor o menor humor o
                                seriedad, cantidad de caracteres, objetivos políticos, etc.</h6>
                        </div>
                        <textarea class="placas-general-prompt" v-model="titulosGeneralInstructions"></textarea>
                    </template>

                </div>
                <div class="col-der cerrada" v-show="activeStep !== 2" @click="activeStep = 2">
                    <h2>3. Resultados</h2>
                </div>
                <div class="col-der" v-show="activeStep === 2">
                    <h2>3. Resultados</h2>
                    <h3 v-if="!titulosCreado">Acá aparecerán los resultados</h3>
                    <div v-if="titulosCreado" class="resultados">
                        <h3>Resultados:</h3>
                        <h4>Títulos</h4>
                        <div class="row" v-for="(result, index) in titulosResultTitulos" :key="index"
                            v-show="titulosResultTitulos">
                            <input type="text" v-model="titulosResultTitulos[index]">
                        </div>
                        <h4>Bajada</h4>
                        <textarea v-show="titulosResultBajada" v-model="titulosResultBajada"></textarea>
                    </div>
                    <div v-if="titulosCreado && articleStatus !== 'completed'" class="pending-status">
                        <p>Estado: {{ articleStatus }}</p>
                        <p>Última actualización: {{ lastUpdated }}</p>
                        <br />
                        <h5>Creando...</h5>
                        <br />
                        <p>La pantalla se recargará automáticamente cuando el proceso termine exitosamente o si hay
                            algún
                            error.</p>
                    </div>
                </div>
                <div v-if="titulosCreado" v-show="activeStep !== 3" class="col-errors cerrada" @click="activeStep = 3">
                    <h2>4. Otros</h2>
                </div>
                <div v-if="titulosCreado" v-show="activeStep === 3" class="col-errors">
                    <h2>4. Otros</h2>
                    <h3>Status:</h3>
                    <p>{{ articleStatus }}</p>
                    <h3>Errores:</h3>
                    <textarea readonly
                        :value="errors && errors?.length > 0 ? errors.map(error => JSON.stringify(error, null, 2)).join('\n\n') : 'No se encontraron.'"
                        class="error"></textarea>
                </div>


            </div>
        </div>



        <div v-if="localSelectedOption === 'Nota' && !is_new_conversation && notaRequest"
            class="nota-input-container modo-nota">
            <div class="tab" v-if="INPUT_SELECTED">
                <div class="cargando" v-if="loadingRequest">Cargando...</div>
                <div v-else>
                    <div class="row">
                        <div class="field">
                            <label>ID:</label>
                            <input type="text" :value="notaRequest._id" readonly>
                        </div>
                        <div class="field">
                            <label>Created At:</label>
                            <input type="text" :value="notaRequest.created_at" readonly>
                        </div>
                        <div class="field">
                            <label>Updated At:</label>
                            <input type="text" :value="notaRequest.updated_at" readonly>
                        </div>
                        <div class="field">
                            <label>User ID:</label>
                            <input type="text" :value="notaRequest.user_id" readonly>
                        </div>
                    </div>
                    <div class="field">
                        <label>General Instructions:</label>
                        <input type="text" :value="notaRequest.request?.general_instructions" readonly>
                    </div>
                    <div class="row">
                        <div class="field column">
                            <label>Sources:</label>
                            <div v-for="(source, index) in notaRequest.request?.sources" :key="index">
                                <input type="text" :value="source" readonly>
                            </div>
                        </div>
                        <div class="field column">
                            <label>Sources Instructions:</label>
                            <div v-for="(instruction, index) in notaRequest.request?.sources_instructions" :key="index">
                                <input type="text" :value="instruction" readonly>
                            </div>
                        </div>
                    </div>
                    <div class="field" v-if="notaRequest.request?.include_many_titles">
                        <label>Include Many Titles Instructions:</label>
                        <input type="text" :value="notaRequest.request?.include_many_titles_instructions" readonly>
                    </div>
                    <div class="field" v-if="notaRequest.request?.use_questions_from_previous_articles">
                        <label>Use Questions From Previous Articles Instructions:</label>
                        <div v-for="(instruction, index) in notaRequest.request?.use_questions_from_previous_articles_instructions"
                            :key="index">
                            <input type="text" :value="instruction" readonly>
                        </div>
                    </div>
                    <div class="field">
                        <label>Copy Style From:</label>
                        <input type="text" :value="notaRequest.request?.copy_style_from" readonly>
                    </div>
                </div>
            </div>
            <div class="tab" v-if="OUTPUT_SELECTED">
                <div class="cargando" v-if="loadingResponse">Cargando...</div>
                <div v-else>
                    <div class="row unica">
                        <div class="column">
                            <div class="field">
                                <label>Status:</label>
                                <input type="text" :value="notaSummary.status" readonly>
                            </div>
                            <div class="field">
                                <label>Título original:</label>
                                <input type="text" :value="notaResponse.response?.raw_article_title" readonly>
                            </div>
                            <div v-if="notaRequest.request?.include_many_titles" class="field">
                                <label>Títulos alternativos:</label>
                                <div v-for="(title, index) in notaResponse.response?.proposed_titles" :key="index">
                                    <input type="text" :value="title" readonly>
                                </div>
                            </div>
                            <div class="field">
                                <label>Resumen:</label>
                                <input type="text" :value="notaResponse.response?.raw_article_summary" readonly>
                            </div>
                        </div>
                        <div class="field column" id="columna-cuerpo">
                            <label>Cuerpo:</label>
                            <textarea
                                :value="notaRequest.request?.copy_style_from ? notaResponse.response?.article_with_style : notaResponse.response?.raw_article_body"
                                readonly>
                    </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab output" v-if="INTERMEDIATE_STEPS_SELECTED">
                <div class="cargando" v-if="loadingResponse">Cargando...</div>
                <div v-else>
                    <div class="field">
                        <label>Extracted Sources:</label>
                        <div v-for="(source, index) in notaResponse.response?.extracted_sources" :key="index">
                            <textarea :value="source" readonly></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <label>Extracted Sources Answers:</label>
                        <div v-for="(answer, index) in notaResponse.response?.extracted_sources_answers" :key="index">
                            <textarea :value="answer" readonly></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <label>Extracted files:</label>
                        <div v-for="(extracted_file, index) in notaResponse.response?.extracted_files" :key="index">
                            <textarea :value="extracted_file" readonly></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <label>Extracted Files Answers:</label>
                        <div v-for="(extracted_file_answer, index) in notaResponse.response?.extracted_files_answers"
                            :key="index">
                            <textarea :value="extracted_file_answer" readonly></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <label>Proposed Titles:</label>
                        <div v-for="(title, index) in notaResponse.response?.proposed_titles" :key="index">
                            <input type="text" :value="title" readonly>
                        </div>
                    </div>
                    <div class="field" v-if="notaResponse.response?.answer_from_previous_articles">
                        <label>Answer From Previous Articles:</label>
                        <div v-for="(answer, index) in notaResponse.response?.answer_from_previous_articles"
                            :key="index">
                            <textarea :value="answer" readonly></textarea>
                        </div>
                    </div>
                    <div class="field">
                        <label>Raw Article Title:</label>
                        <input type="text" :value="notaResponse.response?.raw_article_title" readonly>
                    </div>
                    <div class="field column">
                        <label>Raw Article Body:</label>
                        <textarea :value="notaResponse.response?.raw_article_body" readonly></textarea>
                    </div>
                    <div class="field column">
                        <label>Raw Article Summary:</label>
                        <textarea :value="notaResponse.response?.raw_article_summary" readonly></textarea>
                    </div>
                    <div class="field column">
                        <label>Article With Style:</label>
                        <textarea :value="notaResponse.response?.article_with_style" readonly></textarea>
                    </div>
                </div>
            </div>
            <div class="tab" v-if="ERRORS_SELECTED">
                <div class="cargando" v-if="loadingErrors">Cargando...</div>
                <div v-else>
                    <div class="field row" v-for="(error, index) in errors" :key="index">
                        <label>Error {{ index + 1 }}:</label>
                        <textarea class="error" :value="JSON.stringify(error, null, 2)" readonly></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="localSelectedOption === 'Descargar'" class="option-container modo-descargar">
            <div class="field">
                <label for="download-url">URL:</label>
                <input type="text" v-model="downloadUrl" placeholder="Ingrese URL">
            </div>
            <button @click="downloadArticle">Descargar</button>
            <div class="download-response" v-if="downloadResponse">
                <p>Éxito: {{ !downloadResponse.error }}</p>
                <p>Longitud del cuerpo: {{ downloadResponse.length }}</p>
                <textarea class="downloaded-article" :value="downloadResponse.body" readonly></textarea>
                <div v-if="downloadResponse.error">
                    <label>Error:</label>
                    <textarea class="error-message" :value="downloadResponse.error_message" readonly></textarea>
                </div>
            </div>
        </div>

        <div v-else-if="localSelectedOption === 'Parsear'" class="option-container modo-parsear">
            <div class="field">
                <label for="pdf-file">Seleccionar archivo PDF:</label>
                <input type="file" @change="onFileChange($event, 0)" accept="application/pdf">
            </div>
            <button @click="uploadPdf">Parsear PDF</button>
            <div class="pdf-response" v-if="pdfResponse">
                <p>Éxito: {{ pdfResponse.success }}</p>
                <p>Longitud del cuerpo: {{ pdfResponse.length }}</p>
                <p>Número de páginas: {{ pdfResponse.pages }}</p>
                <p>Metadata: {{ pdfResponse.metadata }}</p>
                <textarea class="parsed-body" :value="pdfResponse.body" readonly></textarea>
                <div v-if="pdfResponse.error_message">
                    <label>Error:</label>
                    <textarea class="error-message" :value="pdfResponse.error_message" readonly></textarea>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import SwitchComponent from './SwitchComponent';
import ResultadosBusquedaLID from './ResultadosBusquedaLID.vue';
import { modosOptions } from '@/utils/modosOptions';

export default {
    components: {
        SwitchComponent,
        ResultadosBusquedaLID
    },

    props: {
        email: {
            type: String,
            required: true
        },
        conversation_id: {
            type: String,
            required: true
        },
        conversation_title: {
            type: String,
            required: true
        },
        is_new_conversation: {
            type: Boolean,
            required: true
        },

        profile_pic: {
            type: String,
            required: false,
            default: null
        },
        userName: {
            type: String,
            required: true
        },
        selectedOption: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            modosOptions,
            sources: [''],
            sourcesInstructions: [''],
            fileSources: [''],
            fileSourcesInstructions: [''],
            incluirTitulos: false,
            instruccionesGenerales: '',
            sacarEstilosDeUrl: '',
            usarNotasPrevias: false,
            usarPreguntasChatPTS: false,
            queryBuscarEnLID: '',
            resultadosBusquedaLid: null,
            resultadosBusquedaLidSeleccionados: null,
            loadingResultadosBusquedaLid: false,
            usarNotasDeLID: false,
            instruccionesTitulos: '',
            instruccionesNotasPrevias: [''],
            articleCreated: false,
            articleId: null,
            articleStatus: 'pending',
            lastUpdated: null,
            showForm: true,
            pollingInterval: null,
            pollingCount: 0,
            notaSummary: {},
            notaRequest: {},
            notaResponse: {},
            loadingSummary: false,
            loadingRequest: false,
            loadingResponse: false,
            INPUT_SELECTED: true,
            OUTPUT_SELECTED: false,
            INTERMEDIATE_STEPS_SELECTED: false,
            errors: [],
            loadingErrors: false,
            ERRORS_SELECTED: false,
            downloadUrl: '',
            downloadResponse: null,
            pdfResponse: null,
            steps: ['Instrucciones Generales', 'Fuentes Externas', 'Información de Archivos', 'Notas propias', 'Otras Opciones', 'Revisar'],
            activeStep: 0,
            lidInstructions: [],
            promptPorDefectoFuentesExternas: 'Extraer información objetiva de los hechos descritos en el artículo. No resumir ni quitar contenido relevante, extraer la mayor cantidad de cosas posible.',

            modosHint: '',

            // Nota
            notaComplejaDesdeLinks: false,
            notaComplejaDesdeTextos: false,
            sourcesTexts: [''],
            sourcesTextsInstructions: [''],


            // Reinterpretar
            reinterpretarDefaultPrompt: 'Si está en idioma diferente al español, traducir.  Reescribir el contenido del artículo original en otras palabras, manteniendo un nivel periodístico profesional pero lenguaje coloquial. Respeta todo el contenido sin resumir ni omitir nada. Tener en cuenta que el contexto es un medio Argentino.',
            reinterpretarDesdeLink: false,
            reinterpretarDesdeTexto: false,
            reinterpretarLinks: [''],
            reinterpretarTextos: [''],
            reinterpretarLinksInstrucciones: [],
            reinterpretarTextosInstrucciones: [],
            reinterpretarCreado: false,
            reinterpretarLoading: false,
            reinterpretarLinkResults: [],
            reinterpretarTextsResults: [],

            // Editorial
            editorialGeneralInstructions: '',
            editorialDesdeLinks: false,
            editorialDesdeTextos: false,
            editorialLineaDesdeChatPTS: false,
            editorialLineaDesdeLinks: false,
            editorialLineaLinks: [''],
            editorialLinks: [''],
            editorialTextos: [''],
            editorialLinksInstructions: [],
            editorialTextosInstructions: [],
            editorialCreado: false,
            editorialLoading: false,
            editorialResult: null,
            editorialDefaultPrompt: 'Identificar el artículo principal y extraer toda la información periodística y objetiva de los hechos descritos en el artículo. No omitir ni resumir nada, extraer la mayor cantidad de hechos objetivos posibles.',
            editorialGeneralInstructionDefaultPrompt: 'Combinar las descripciones periodísticas de los hechos en las fuentes y crear un artículo sobre ese tema que combine lo más importante de cada fuente en conjunto con la mirada política, posicionamiento, denuncias y propuestas de La Izquierda Diario.',

            // Placas
            placasGeneralInstructions: '',
            placasDesdeLinks: false,
            placasDesdeTextos: false,
            placasLinks: [''],
            placasTextos: [''],
            placasCreado: false,
            placasLoading: false,
            placasResult: null,
            placasGeneralInstructionDefaultPrompt: 'Combinar la información más importante de las fuentes para realizar un guion para un carrusel de placas de Instagram. Proveer hasta 15 diapositivas indicando los textos de cada una, jerarquías, etc. Pensar políticamente el contenido en función de lo quiere transmitir La Izquierda Diario sobre ese tema, con qué tono hablar, qué denuncias hacer, etc.',

            // Twitter
            twitterGeneralInstructions: '',
            twitterDesdeLinks: false,
            twitterDesdeTextos: false,
            twitterLinks: [''],
            twitterTextos: [''],
            twitterCreado: false,
            twitterLoading: false,
            twitterResult: null,
            twitterGeneralInstructionDefaultPrompt: 'Combinar la información más importante de las fuentes para realizar un hilo de Twitter listo para publicar. Proveer tuits de hasta  280 caracteres indicando los textos de cada uno, jerarquías, etc. Pensar políticamente el contenido en función de lo quiere transmitir La Izquierda Diario.',
            presentAuthor: false,
            minNumberOfTwits: 10,
            maxNumberOfTwits: 15,

            // Guion videos
            guionGeneralInstructions: '',
            guionDesdeLinks: false,
            guionDesdeTextos: false,
            guionLinks: [''],
            guionTextos: [''],
            guionCreado: false,
            guionLoading: false,
            guionResult: null,
            guionGeneralInstructionDefaultPrompt: 'Combinar la información más importante de las fuentes para realizar un guion de un video breve para redes sociales. Que dure entre 30 y 60 segundos aproximadamente y que consista de una persona hablando a cámara explicando el tema. Puede contener también imágenes / gráficos / cifras y otros elementos visuales agregados. Pensar políticamente el contenido en función de lo quiere transmitir La Izquierda Diario. Usar lenguaje coloquial accesible a todo el mundo, destinado a público argentino.',

            // Correcciones de texto
            correctionGeneralInstructions: '',
            correctionDesdeTextos: false,
            correctionTextos: [''],
            correctionCreado: false,
            correctionLoading: false,
            correctionResult: null,
            correctionGeneralInstructionDefaultPrompt: 'Te voy a pasar una descripción para un posteo de Instagram. Necesito que me la corrijas tanto en redacción como en ortografía sin hacer cambios que modifiquen el contenido.',


            // Titulos
            titulosGeneralInstructions: '',
            titulosCantidad: 3,
            titulosDesdeLinks: false,
            titulosDesdeTextos: false,
            titulosLinks: [''],
            titulosTextos: [''],
            titulosCreado: false,
            titulosLoading: false,
            titulosResultTitulos: null,
            titulosResultBajada: null,
            titulosGeneralInstructionDefaultPrompt: 'Generar títulos atractivos sobre el contenido que destaquen la principal línea política del contenido. Que sean dinámicos, atractivos y llamen la atención en un medio de izuqierda y en las redes sociales, así como en buscadores de Internet.',


            // OTHER
            localSelectedOption: this.selectedOption,
        }
    },
    watch: {
        conversation_id(new_val, old_val) {
            console.log('conversation_id changed');
            console.log('new_val:', new_val);
            console.log('old_val:', old_val);
            if (new_val && !this.is_new_conversation) {
                if (this.selectedOption === "Nota") {
                    this.fetchArticleSummary(new_val);
                    this.fetchArticleRequest(new_val);
                    this.fetchArticleResponse(new_val);
                    this.fetchArticleErrors(new_val);
                    this.selectTab('OUTPUT');
                } else if (this.selectedOption === "Reinterpretar") {
                    this.fetchReinterpretar(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Editorial") {
                    this.fetchEditorial(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Placas") {
                    this.fetchPlacas(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Twitter") {
                    this.fetchTwitter(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Guion") {
                    this.fetchGuion(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Corrector") {
                    this.fetchCorrection(new_val);
                    this.activeStep = 2;
                } else if (this.selectedOption === "Títulos") {
                    this.fetchTitulos(new_val);
                    this.activeStep = 2;
                } else {
                    // Alert that this mode is not yet implemented
                    this.showToast('Este modo aún no está implementado', 'error');
                }
            }
            if (new_val && this.is_new_conversation) {
                this.localSelectedOption = this.selectedOption;
                this.activeStep = 0;
                this.cleanReinterpretations();
                this.cleanEditorials();
                this.cleanPlacas();
                this.cleanTwitter();
                this.cleanGuion();
                this.cleanTitulos();
                this.cleanCorrection();
            }
        },
        is_new_conversation(new_val, old_val) {
            console.log('is_new_conversation changed');
            console.log('new_val:', new_val);
            console.log('old_val:', old_val);
        },
        sources: {
            handler(new_val) {
                console.log('sources changed');
                console.log('new_val:', new_val);
                for (let i = 0; i < new_val.length; i++) {
                    if (new_val[i] != '') {
                        if (!this.sourcesInstructions[i] || this.sourcesInstructions[i] === '') {
                            this.sourcesInstructions[i] = this.promptPorDefectoFuentesExternas;
                        }
                    } else {
                        this.sourcesInstructions[i] = '';
                    }
                }
            },
            deep: true
        },
        sourcesTexts: {
            handler(new_val) {
                console.log('sourcesTexts changed');
                console.log('new_val:', new_val);
                for (let i = 0; i < new_val.length; i++) {
                    if (new_val[i] != '') {
                        if (!this.sourcesTextsInstructions[i] || this.sourcesTextsInstructions[i] === '') {
                            this.sourcesTextsInstructions[i] = this.promptPorDefectoFuentesExternas;
                        }
                    } else {
                        this.sourcesTextsInstructions[i] = '';
                    }
                }
            },
            deep: true
        },
        // When reinterpretarTextos changes, initialize the reinterpretarTextosInstrucciones array with reinterpretarDefaultPrompt
        reinterpretarTextos: {
            handler(new_val) {
                console.log('reinterpretarTextos changed');
                console.log('new_val:', new_val);
                for (let i = 0; i < new_val?.length; i++) {
                    if (new_val[i] != '') {
                        if (!this.reinterpretarTextosInstrucciones[i] || this.reinterpretarTextosInstrucciones[i] === '') {
                            this.reinterpretarTextosInstrucciones[i] = this.reinterpretarDefaultPrompt;
                        }
                    } else {
                        this.reinterpretarTextosInstrucciones[i] = '';
                    }
                }
            },
            deep: true
        },
        reinterpretarLinks: {
            handler(new_val) {
                console.log('reinterpretarLinks changed');
                console.log('new_val:', new_val);

                for (let i = 0; i < new_val?.length; i++) {
                    if (new_val[i] != '') {
                        if (!this.reinterpretarLinksInstrucciones[i] || this.reinterpretarLinksInstrucciones[i] === '') {
                            this.reinterpretarLinksInstrucciones[i] = this.reinterpretarDefaultPrompt;
                        }
                    } else {
                        this.reinterpretarLinksInstrucciones[i] = '';
                    }
                }
            },
            deep: true
        },
        editorialLinks: {
            handler(new_val) {
                console.log('editorialLinks changed');
                console.log('new_val:', new_val);

                if (new_val) {
                    if (new_val.length > 0 && this.editorialGeneralInstructions === '') {
                        this.editorialGeneralInstructions = this.editorialGeneralInstructionDefaultPrompt;
                    }

                    for (let i = 0; i < new_val.length; i++) {
                        if (new_val[i] != '') {
                            if (!this.editorialLinksInstructions[i] || this.editorialLinksInstructions[i] === '') {
                                this.editorialLinksInstructions[i] = this.editorialDefaultPrompt;
                            }
                        } else {
                            this.editorialLinksInstructions[i] = '';
                        }
                    }
                }
            },
            deep: true
        },
        editorialTextos: {
            handler(new_val) {
                console.log('editorialTextos changed');
                console.log('new_val:', new_val);

                if (new_val) {
                    if (new_val.length > 0 && this.editorialGeneralInstructions === '') {
                        this.editorialGeneralInstructions = this.editorialGeneralInstructionDefaultPrompt;
                    }


                    for (let i = 0; i < new_val.length; i++) {
                        if (new_val[i] != '') {
                            if (!this.editorialTextosInstructions[i] || this.editorialTextosInstructions[i] === '') {
                                this.editorialTextosInstructions[i] = this.editorialDefaultPrompt;
                            }
                        } else {
                            this.editorialTextosInstructions[i] = '';
                        }
                    }
                }
            },
            deep: true
        },
        // When placasTextos or placasLinks changes, if the placasGeneralInstructions is empty, initialize it with placasGeneralInstructionDefaultPrompt
        placasTextos: {
            handler(new_val) {
                console.log('placasTextos changed');
                console.log('new_val:', new_val);

                if (new_val && new_val.length > 0 && this.placasGeneralInstructions === '') {
                    this.placasGeneralInstructions = this.placasGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        placasLinks: {
            handler(new_val) {
                console.log('placasLinks changed');
                console.log('new_val:', new_val);

                if (new_val && new_val.length > 0 && this.placasGeneralInstructions === '') {
                    this.placasGeneralInstructions = this.placasGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        // When twitterTextos or twitterLinks changes, if the twitterGeneralInstructions is empty, initialize it with twitterGeneralInstructionDefaultPrompt
        twitterTextos: {
            handler(new_val) {
                console.log('twitterTextos changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.twitterGeneralInstructions === '') {
                    this.twitterGeneralInstructions = this.twitterGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        twitterLinks: {
            handler(new_val) {
                console.log('twitterLinks changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.twitterGeneralInstructions === '') {
                    this.twitterGeneralInstructions = this.twitterGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        guionTextos: {
            handler(new_val) {
                console.log('guionTextos changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.guionGeneralInstructions === '') {
                    this.guionGeneralInstructions = this.guionGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        guionLinks: {
            handler(new_val) {
                console.log('guionLinks changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.guionGeneralInstructions === '') {
                    this.guionGeneralInstructions = this.guionGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        correctionTextos: {
            handler(new_val) {
                console.log('correctionTextos changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.correctionGeneralInstructions === '') {
                    this.correctionGeneralInstructions = this.correctionGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        // When titulosTextos or titulosLinks changes, if the titulosGeneralInstructions is empty, initialize it with titulosGeneralInstructionDefaultPrompt
        titulosTextos: {
            handler(new_val) {
                console.log('titulosTextos changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.titulosGeneralInstructions === '') {
                    this.titulosGeneralInstructions = this.titulosGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },
        titulosLinks: {
            handler(new_val) {
                console.log('titulosLinks changed');
                console.log('new_val:', new_val);

                if (new_val && new_val?.length > 0 && this.titulosGeneralInstructions === '') {
                    this.titulosGeneralInstructions = this.titulosGeneralInstructionDefaultPrompt;
                }
            },
            deep: true
        },


        // When reinterpretarLinks changes, initialize the instructions array with reinterpretarDefaultPrompt
        selectedOption(newVal) {
            // Update component's selectedOption
            console.log("selectedOption changed", newVal);
            this.localSelectedOption = newVal;
        },
    },
    computed: {
        canSubmit() {
            // Check if required fields are filled
            return (
                this.instruccionesGenerales &&
                this.instruccionesGenerales.length > 0
                // Add additional checks as needed
            );
        },
        selectedStepName() {
            return this.steps[this.activeStep];
        }
    },
    methods: {
        addSource() {
            this.sources.push('');
        },
        removeSource() {
            this.sources.pop();
        },
        addSourceText() {
            this.sourcesTexts.push('');
        },
        removeSourceText() {
            this.sourcesTexts.pop();
        },
        addFileSource() {
            this.fileSources.push('');
        },
        removeFileSource() {
            this.fileSources.pop();
        },
        addInstruccionNotaPrevia() {
            this.instruccionesNotasPrevias.push('');
        },
        removeInstruccionNotaPrevia() {
            this.instruccionesNotasPrevias.pop();
        },
        async createArticle() {
            if (!this.canSubmit) {
                this.showToast('Por favor completar al menos instrucciones generales (paso 1)', 'error');
                return;
            }

            let use_files = false;
            let pdf_files_ids = [];
            if (this.fileSources.length > 0) {
                if (this.fileSources[0] !== '') {
                    use_files = true;
                    for (let i = 0; i < this.fileSources.length; i++) {
                        const file = this.fileSources[i];
                        const fileInstructions = this.fileSourcesInstructions[i];

                        if (file && fileInstructions) {
                            const formData = new FormData();
                            formData.append('file', file);
                            try {
                                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/upload-and-store-pdf/`, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                });
                                if (response.data.success) {
                                    pdf_files_ids.push(response.data._id);
                                } else {
                                    this.showToast(`Error al subir el archivo ${file.name}: ${response.data.error_message}`, 'error');
                                    return;
                                }
                            } catch (error) {
                                this.showToast(`Error al subir el archivo ${file.name}: ${error.message}`, 'error');
                                return;
                            }
                        }
                    }
                }
            }

            const articleData = {
                sources: this.sources,
                sources_instructions: this.sourcesInstructions,
                sources_texts: this.sourcesTexts,
                sources_texts_instructions: this.sourcesTextsInstructions,
                general_instructions: this.instruccionesGenerales,
                include_many_titles: this.incluirTitulos,
                include_many_titles_instructions: this.instruccionesTitulos,
                use_questions_from_previous_articles: this.usarPreguntasChatPTS,
                use_questions_from_previous_articles_instructions: this.instruccionesNotasPrevias,
                use_previous_articles_from_db: this.usarNotasDeLID,
                previous_articles_to_use: this.resultadosBusquedaLidSeleccionados ? this.resultadosBusquedaLidSeleccionados.map(nota => nota.title) : [],
                previous_articles_to_use_instructions: this.lidInstructions ? this.lidInstructions.map(instructions => instructions.instructions) : [],
                copy_style_from: this.sacarEstilosDeUrl,
                use_files: use_files,
                pdf_files_ids: pdf_files_ids,
                pdf_files_instructions: this.fileSourcesInstructions,
            };
            axios.post(process.env.VUE_APP_BASE_URL + '/api/v2/redaccion/request-article-creation/', articleData)
                .then(response => {
                    if (response.status === 200) {
                        this.articleCreated = true;
                        this.showToast('Artículo en proceso de composición', 'success');
                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();
                        this.showForm = false;
                        this.startPolling();
                    }
                })
                .catch(error => {
                    console.error(error);
                    const errorMessage = error.response?.data?.detail || 'Error al crear el artículo';
                    this.showToast(errorMessage, 'error');
                });
        },
        startPolling(mode = 'article') {
            this.pollingInterval = setInterval(() => {
                this.checkArticleStatus(mode);
            }, 15000); // Every 15 seconds
        },
        checkArticleStatus(mode = 'article') {
            this.pollingCount++;
            if (this.pollingCount >= 15) {
                clearInterval(this.pollingInterval);
                return;
            }

            const endpoint = `/api/v2/redaccion/request-${mode}-status/${this.articleId}/`

            axios.get(process.env.VUE_APP_BASE_URL + endpoint)
                .then(response => {
                    this.articleStatus = response.data.status;
                    this.lastUpdated = new Date().toLocaleString();
                    if (this.articleStatus === 'failed' || this.articleStatus === 'completed') {
                        clearInterval(this.pollingInterval);
                        // Reload the page to show the updated data
                        const currentUrl = window.location.href.split('?')[0];
                        window.location.href = `${currentUrl}?agente=${mode}`;
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        toggleForm() {
            this.showForm = !this.showForm;
        },
        fetchArticleSummary(article_id) {
            this.loadingSummary = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get/${article_id}/`)
                .then(response => {
                    this.notaSummary = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingSummary = false;
                });
        },
        fetchArticleRequest(article_id) {
            this.loadingRequest = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-article-request/${article_id}/`)
                .then(response => {
                    this.notaRequest = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingRequest = false;
                });
        },
        fetchArticleResponse(article_id) {
            this.loadingResponse = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-article-response/${article_id}/`)
                .then(response => {
                    this.notaResponse = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingResponse = false;
                });
        },
        fetchArticleErrors(article_id) {
            this.loadingErrors = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-article-errors/${article_id}/`)
                .then(response => {
                    this.errors = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loadingErrors = false;
                });
        },
        fetchReinterpretar(article_id) {
            this.loadingReinterpretar = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-reinterpretar/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    this.reinterpretarCreado = true;
                    this.reinterpretarLoading = false;
                    this.reinterpretarLinks = body.request.link_sources;
                    this.reinterpretarLinksInstrucciones = body.request.link_sources_instructions;
                    this.reinterpretarTextos = body.request.text_sources;
                    this.reinterpretarTextosInstrucciones = body.request.text_sources_instructions;
                    this.reinterpretarDesdeLink = body.request.use_links;
                    this.reinterpretarDesdeTexto = body.request.use_texts;
                    this.reinterpretarLinkResults = body.response?.extracted_link_sources_answers;
                    this.reinterpretarTextsResults = body.response?.extracted_text_sources_answers;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.reinterpretarCreado = false;
                    this.reinterpretarLoading = false;
                });
        },
        fetchEditorial(article_id) {
            this.loadingEditorial = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-editorial/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('editorial body:', body);
                    this.editorialCreado = true;
                    this.editorialLoading = false;
                    this.editorialDesdeLinks = body.request.use_links;
                    this.editorialDesdeTextos = body.request.use_texts;
                    this.editorialLinks = body.request.link_sources;
                    this.editorialLinksInstructions = body.request.link_sources_instructions;
                    this.editorialTextos = body.request.text_sources;
                    this.editorialTextosInstructions = body.request.text_sources_instructions;
                    this.editorialLineaDesdeChatPTS = body.request.editorial_linea_chatpts;
                    console.log('editorialLineaDesdeChatPTS:', body.request.editorial_linea_chatpts);

                    this.editorialLineaDesdeLinks = body.request.editorial_linea_desde_links;
                    this.editorialLineaLinks = body.request.editorial_linea_links;
                    this.editorialGeneralInstructions = body.request.general_instructions;
                    console.log('editorialGeneralInstructions:', body.request.general_instructions);

                    this.editorialResult = body.response?.article;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.editorialCreado = false;
                    this.editorialLoading = false;
                });
        },
        fetchPlacas(article_id) {
            this.loadingPlacas = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-placas/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('placas body:', body);
                    this.placasCreado = true;
                    this.placasLoading = false;
                    this.placasDesdeLinks = body.request.use_links;
                    this.placasDesdeTextos = body.request.use_texts;
                    this.placasLinks = body.request.link_sources;
                    this.placasTextos = body.request.text_sources;
                    this.placasGeneralInstructions = body.request.general_instructions;

                    this.placasResult = body.response?.placas;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.placasCreado = false;
                    this.placasLoading = false;
                });
        },
        fetchTwitter(article_id) {
            this.loadingTwitter = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-thread/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('twitter body:', body);
                    this.twitterCreado = true;
                    this.twitterLoading = false;
                    this.twitterDesdeLinks = body.request.use_links;
                    this.twitterDesdeTextos = body.request.use_texts;
                    this.twitterLinks = body.request.link_sources;
                    this.twitterTextos = body.request.text_sources;
                    this.twitterGeneralInstructions = body.request.general_instructions;
                    this.presentAuthor = body.request.present_author;
                    this.minNumberOfTwits = body.request.min_number_of_twits;
                    this.maxNumberOfTwits = body.request.max_number_of_twits;

                    this.twitterResult = body.response?.thread;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.twitterCreado = false;
                    this.twitterLoading = false;
                });
        },
        fetchGuion(article_id) {
            this.loadingGuion = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-script/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('guion body:', body);
                    this.guionCreado = true;
                    this.guionLoading = false;
                    this.guionDesdeLinks = body.request.use_links;
                    this.guionDesdeTextos = body.request.use_texts;
                    this.guionLinks = body.request.link_sources;
                    this.guionTextos = body.request.text_sources;
                    this.guionGeneralInstructions = body.request.general_instructions;

                    this.guionResult = body.response?.script;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.guionCreado = false;
                    this.guionLoading = false;
                });
        },
        fetchCorrection(article_id) {
            this.loadingCorrection = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-correction/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('correction body:', body);
                    this.correctionCreado = true;
                    this.correctionLoading = false;
                    this.correctionDesdeTextos = body.request.use_texts;
                    this.correctionTextos = body.request.text_sources;
                    this.correctionGeneralInstructions = body.request.general_instructions;

                    this.correctionResult = body.response?.correction;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.correctionCreado = false;
                    this.correctionLoading = false;
                });
        },
        fetchTitulos(article_id) {
            this.loadingTitulos = true;
            axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/get-titles/${article_id}/`)
                .then(response => {
                    const body = response.data;
                    this.notaRequest = response.data;
                    console.log('títulos body:', body);
                    this.titulosCreado = true;
                    this.titulosLoading = false;
                    this.titulosCantidad = body.request.cantidad;
                    this.titulosDesdeLinks = body.request.use_links;
                    this.titulosDesdeTextos = body.request.use_texts;
                    this.titulosLinks = body.request.link_sources;
                    this.titulosTextos = body.request.text_sources;
                    this.titulosGeneralInstructions = body.request.general_instructions;

                    this.titulosResultTitulos = body.response?.titles;
                    this.titulosResultBajada = body.response?.bajada;

                    this.errors = body.errors;
                    this.articleStatus = body.status;
                })
                .catch(error => {
                    console.error(error);
                    this.titulosCreado = false;
                    this.titulosLoading = false;
                });
        },
        selectTab(tab) {
            this.INPUT_SELECTED = tab === 'INPUT';
            this.OUTPUT_SELECTED = tab === 'OUTPUT';
            this.INTERMEDIATE_STEPS_SELECTED = tab === 'PASOS INTERMEDIOS';
            this.ERRORS_SELECTED = tab === 'ERRORS';
        },
        showToast(message, type) {
            this.$emit('show-toast', message, type);
        },
        async downloadArticle() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/download-article/`, {
                    params: { url: this.downloadUrl }
                });
                this.downloadResponse = response.data;
            } catch (error) {
                console.error(error);
                this.downloadResponse = { error: true, body: null, length: 0, error_message: error.message };
            }
        },
        onFileChange(event, index) {
            this.fileSources[index] = event.target.files[0];
        },
        async uploadPdf() {
            if (!this.fileSources) {
                this.showToast('Por favor seleccione un archivo PDF', 'error');
                return;
            }

            const formData = new FormData();
            formData.append('file', this.fileSources[0]);

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/upload-pdf/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                this.pdfResponse = response.data;
            } catch (error) {
                console.error(error);
                this.pdfResponse = { success: false, body: null, length: 0, pages: 0, metadata: {}, error_message: error.message };
            }
        },
        canSiguiente() {
            if (this.activeStep === 0) {
                if (this.instruccionesGenerales.length < 10) {
                    this.showToast('Por favor ingresar instrucciones generales de al menos 10 caracteres', 'error');
                    return false;
                }
            } else if (this.activeStep === 1) {
                if (this.sources.length === 1) {
                    if ((this.sources[0] !== '' && this.sourcesInstructions[0] === '') || (this.sources[0] === '' && this.sourcesInstructions[0] !== '')) {
                        this.showToast('Falta completar la URL o las instrucciones de la fuente externa', 'error');
                        return false;
                    }
                } else if (this.sources.length > 1) {
                    for (let i = 0; i < this.sources.length; i++) {
                        if ((this.sources[i] !== '' && this.sourcesInstructions[i] === '') || (this.sources[i] === '' && this.sourcesInstructions[i] !== '')) {
                            this.showToast('Falta completar las instrucciones de la fuente externa', 'error');
                            return false;
                        }
                    }
                }
                if (this.sourcesTexts.length === 1) {
                    if ((this.sourcesTexts[0] !== '' && this.sourcesTextsInstructions[0] === '') || (this.sourcesTexts[0] === '' && this.sourcesTextsInstructions[0] !== '')) {
                        this.showToast('Falta completar el texto o las instrucciones del texto', 'error');
                        return false;
                    }
                } else if (this.sourcesTexts.length > 1) {
                    for (let i = 0; i < this.sourcesTexts.length; i++) {
                        if ((this.sourcesTexts[i] !== '' && this.sourcesTextsInstructions[i] === '') || (this.sourcesTexts[i] === '' && this.sourcesTextsInstructions[i] !== '')) {
                            this.showToast('Falta completar las instrucciones del texto', 'error');
                            return false;
                        }
                    }
                }
            } else if (this.activeStep === 2) {
                if (this.fileSources.length === 1) {
                    if ((this.fileSources[0] !== '' && this.fileSourcesInstructions[0] === '') || (this.fileSources[0] === '' && this.fileSourcesInstructions[0] !== '')) {
                        this.showToast('Falta adjuntar el archivo o las instrucciones del archivo', 'error');
                        return false;
                    }
                } else if (this.fileSources.length > 1) {
                    for (let i = 0; i < this.fileSources.length; i++) {
                        if ((this.fileSources[i] !== '' && this.fileSourcesInstructions[i] === '') || (this.fileSources[i] === '' && this.fileSourcesInstructions[i] !== '')) {
                            this.showToast('Falta completar las instrucciones del archivo', 'error');
                            return false;
                        }
                    }
                }
            } else if (this.activeStep === 3) {
                if (this.usarNotasPrevias && !this.usarPreguntasChatPTS && !this.usarNotasDeLID) {
                    this.showToast('Si se activa "Usar información de notas previas", deben incluirse preguntas al chat o buscar notas de LID específicas', 'error');
                    return false;
                }
                if (this.usarNotasPrevias && this.usarPreguntasChatPTS && this.instruccionesNotasPrevias.length === 0) {
                    this.showToast('Por favor ingresar al menos una pregunta para ChatPTS', 'error');
                    return false;
                }
                if (this.usarNotasPrevias && this.usarPreguntasChatPTS) {
                    if (this.instruccionesNotasPrevias.length === 1) {
                        if (this.instruccionesNotasPrevias[0] === '') {
                            this.showToast('Por favor ingresar al menos una pregunta para ChatPTS', 'error');
                            return false;
                        }
                    } else if (this.instruccionesNotasPrevias.length > 1) {
                        for (let i = 0; i < this.instruccionesNotasPrevias.length; i++) {
                            if (this.instruccionesNotasPrevias[i] === '') {
                                this.showToast('Por favor ingresar preguntas para todas las notas previas seleccionadas', 'error');
                                return false;
                            }
                        }
                    }
                }
                if (this.usarNotasPrevias && this.usarNotasDeLID && !this.resultadosBusquedaLidSeleccionados) {
                    this.showToast('Por favor seleccionar al menos una nota de LID', 'error');
                    return false;
                }
                if (this.usarNotasPrevias && this.usarNotasDeLID) {
                    if (this.resultadosBusquedaLidSeleccionados.length !== this.lidInstructions.length) {
                        this.showToast('Por favor ingresar instrucciones para todas las notas de LID seleccionadas', 'error');
                        return false;
                    }
                    for (let i = 0; i < this.resultadosBusquedaLidSeleccionados.length; i++) {
                        if (this.lidInstructions[i].instructions === '' || this.lidInstructions[i].instructions.length < 10) {
                            this.showToast('Por favor ingresar instrucciones para todas las notas de LID seleccionadas (al menos 10 caracteres)', 'error');
                            return false;
                        }
                    }
                }
            } else if (this.activeStep === 4) {
                if (this.incluirTitulos && this.instruccionesTitulos.length < 10) {
                    this.showToast('Por favor ingresar instrucciones para los títulos (al menos 10 caracteres)', 'error');
                    return false;
                }
            }
            return true;
        },
        nextStep() {
            if (!this.canSiguiente()) {
                return;
            }
            if (this.activeStep < this.steps.length - 1) {
                this.activeStep++;
            }
        },
        previousStep() {
            if (this.activeStep > 0) {
                this.activeStep--;
            }
        },
        async buscarEnLid() {
            this.loadingResultadosBusquedaLid = true;
            try {
                const response = await axios.get(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/search-lid-article/`, {
                    params: { query: this.queryBuscarEnLID }
                });
                this.resultadosBusquedaLid = response.data?.results;
                this.loadingResultadosBusquedaLid = false;
            } catch (error) {
                console.error(error);
                this.resultadosBusquedaLid = null;
                this.showToast('Error al buscar en LID', 'error');
                this.loadingResultadosBusquedaLid = false;
            }
        },
        addSelectedResult(result) {
            if (!this.resultadosBusquedaLidSeleccionados) {
                this.resultadosBusquedaLidSeleccionados = [];
            }
            this.resultadosBusquedaLidSeleccionados.push(result);
        },
        removeSelectedResult(result) {
            console.log("Result to remove", result);
            this.resultadosBusquedaLidSeleccionados = this.resultadosBusquedaLidSeleccionados.filter(r => r.title !== result.title);
            this.lidInstructions = this.lidInstructions.filter(item => item.title !== result.title);
        },
        updateLidInstructions({ result, value }) {
            const index = this.lidInstructions.findIndex(item => item.title === result.title);
            if (index !== -1) {
                this.lidInstructions[index].instructions = value;
            } else {
                this.lidInstructions.push({ title: result.title, instructions: value });
            }
        },
        retryComposeArticle() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-article/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Artículo en proceso de re-composición', 'success');
                        this.articleCreated = true;
                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();
                        this.showForm = false;
                        this.startPolling();
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-componer el artículo', 'error');
                });
        },
        retryReinterpretarCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-reinterpretation/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Reinterpretación en proceso de re-creación', 'success');
                        this.reinterpretarCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('reinterpretation');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear la reinterpretación', 'error');
                });
        },
        retryEditorialCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-editorial/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Editorial en proceso de re-creación', 'success');
                        this.editorialCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('editorial');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear la editorial', 'error');
                });
        },
        retryPlacasCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-placas/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Placas en proceso de re-creación', 'success');
                        this.placasCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('placas');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear las placas', 'error');
                });
        },
        retryTwitterCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-thread/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Hilo de Twitter en proceso de re-creación', 'success');
                        this.twitterCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('thread');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear el hilo de Twitter', 'error');
                });
        },
        retryGuionCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-script/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Guion en proceso de re-creación', 'success');
                        this.guionCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('script');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear el guion', 'error');
                });
        },
        retryCorrectionCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-correction/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Corrección en proceso de re-creación', 'success');
                        this.correctionCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('correction');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear la corrección', 'error');
                });
        },
        retryTitulosCreado() {
            axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/retry-compose-titles/${this.notaRequest._id}/`)
                .then(response => {
                    if (response.status === 200) {
                        this.showToast('Títulos en proceso de re-creación', 'success');
                        this.titulosCreado = true;

                        this.articleId = response.data._id;
                        this.articleStatus = 'pending';
                        this.lastUpdated = new Date().toLocaleString();

                        this.startPolling('titles');
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.showToast('Error al re-crear Títulosr', 'error');
                });
        },
        addReinterpretarLink() {
            this.reinterpretarLinks.push('');
        },
        addReinterpretarTexto() {
            this.reinterpretarTextos.push('');
        },
        removeReinterpretarLink() {
            this.reinterpretarLinks.pop();
        },
        removeReinterpretarTexto() {
            this.reinterpretarTextos.pop();
        },
        addEditorialLineaLink() {
            this.editorialLineaLinks.push('');
        },
        removeEditorialLineaLink() {
            this.editorialLineaLinks.pop();
        },
        addEditorialLink() {
            this.editorialLinks.push('');
        },
        addEditorialTexto() {
            this.editorialTextos.push('');
        },
        removeEditorialLink() {
            this.editorialLinks.pop();
        },
        removeEditorialTexto() {
            this.editorialTextos.pop();
        },
        addPlacaLink() {
            this.placasLinks.push('');
        },
        removePlacaLink() {
            this.placasLinks.pop();
        },
        addPlacaTexto() {
            this.placasTextos.push('');
        },
        removePlacaTexto() {
            this.placasTextos.pop();
        },
        addTwitterLink() {
            this.twitterLinks.push('');
        },
        removeTwitterLink() {
            this.twitterLinks.pop();
        },
        addTwitterTexto() {
            this.twitterTextos.push('');
        },
        removeTwitterTexto() {
            this.twitterTextos.pop();
        },
        addGuionLink() {
            this.guionLinks.push('');
        },
        removeGuionLink() {
            this.guionLinks.pop();
        },
        addGuionTexto() {
            this.guionTextos.push('');
        },
        removeGuionTexto() {
            this.guionTextos.pop();
        },
        addCorrectionTexto() {
            this.correctionTextos.push('');
        },
        removeCorrectionTexto() {
            this.correctionTextos.pop();
        },
        addTitulosLink() {
            this.titulosLinks.push('');
        },
        removeTitulosLink() {
            this.titulosLinks.pop();
        },
        addTitulosTexto() {
            this.titulosTextos.push('');
        },
        removeTitulosTexto() {
            this.titulosTextos.pop();
        },
        canSubmitReinterpretar() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            if (
                (this.reinterpretarLinks.some(link => link !== '') || this.reinterpretarTextos.some(texto => texto !== ''))
                && (this.reinterpretarLinksInstrucciones.some(instruccion => instruccion !== '') || this.reinterpretarTextosInstrucciones.some(instruccion => instruccion !== '')
                )) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createReinterpretar() {
            if (!this.canSubmitReinterpretar()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción', 'error');
                return;
            }

            const reinterpretarData = {
                use_links: this.reinterpretarDesdeLink,
                link_sources: this.reinterpretarLinks,
                link_sources_instructions: this.reinterpretarLinksInstrucciones,
                use_texts: this.reinterpretarDesdeTexto,
                text_sources: this.reinterpretarTextos,
                text_sources_instructions: this.reinterpretarTextosInstrucciones,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-reinterpretation-creation/`, reinterpretarData);
                if (response.status === 200) {
                    this.reinterpretarCreado = true;
                    this.showToast('Reinterpretación en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('reinterpretation');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear la reinterpretación', 'error');
            }
        },
        canSubmitEditorial() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            // and that at least 1 general instruction is filled
            // and that either editorialLineaDesdeChatPTS or editorialLineaDesdeLinks is true
            if (
                (this.editorialLinks.some(link => link !== '') || this.editorialTextos.some(texto => texto !== ''))
                && (this.editorialLinksInstructions.some(instruccion => instruccion !== '') || this.editorialTextosInstructions.some(instruccion => instruccion !== '')
                )
                && this.editorialGeneralInstructions.length > 0
                && (this.editorialLineaDesdeChatPTS || (this.editorialLineaDesdeLinks && this.editorialLineaLinks.some(link => link !== '')))
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createEditorial() {
            if (!this.canSubmitEditorial()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción, las instrucciones generales y seleccionar linea editorial desde ChatPTS o desde un link específico', 'error');
                return;
            }

            const editorialData = {
                use_links: this.editorialDesdeLinks,
                link_sources: this.editorialLinks,
                link_sources_instructions: this.editorialLinksInstructions,
                use_texts: this.editorialDesdeTextos,
                text_sources: this.editorialTextos,
                text_sources_instructions: this.editorialTextosInstructions,
                general_instructions: this.editorialGeneralInstructions,
                editorial_linea_chatpts: this.editorialLineaDesdeChatPTS,
                editorial_linea_desde_links: this.editorialLineaDesdeLinks,
                editorial_linea_links: this.editorialLineaLinks,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-editorial-creation/`, editorialData);
                if (response.status === 200) {
                    this.editorialCreado = true;
                    this.showToast('Editorial en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();


                    this.startPolling('editorial');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear el editorial', 'error');
            }
        },
        canSubmitPlacas() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            // and that at least 1 general instruction is filled
            if (
                (this.placasLinks.some(link => link !== '') || this.placasTextos.some(texto => texto !== ''))
                && this.placasGeneralInstructions.length > 0
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createPlacas() {
            if (!this.canSubmitPlacas()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción', 'error');
                return;
            }

            const placasData = {
                use_links: this.placasDesdeLinks,
                link_sources: this.placasLinks,
                link_sources_instructions: this.placasLinksInstructions,
                use_texts: this.placasDesdeTextos,
                text_sources: this.placasTextos,
                text_sources_instructions: this.placasTextosInstructions,
                general_instructions: this.placasGeneralInstructions,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-placas-creation/`, placasData);
                if (response.status === 200) {
                    this.placasCreado = true;
                    this.showToast('Placas en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('placas');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear las placas', 'error');
            }
        },
        canSubmitTwitter() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            // and that at least 1 general instruction is filled
            if (
                (this.twitterLinks.some(link => link !== '') || this.twitterTextos.some(texto => texto !== ''))
                && this.twitterGeneralInstructions.length > 0
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createTwitter() {
            if (!this.canSubmitTwitter()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción', 'error');
                return;
            }

            const twitterData = {
                use_links: this.twitterDesdeLinks,
                link_sources: this.twitterLinks,
                link_sources_instructions: this.twitterLinksInstructions,
                use_texts: this.twitterDesdeTextos,
                text_sources: this.twitterTextos,
                text_sources_instructions: this.twitterTextosInstructions,
                general_instructions: this.twitterGeneralInstructions,
                present_author: this.presentAuthor,
                min_number_of_twits: this.minNumberOfTwits,
                max_number_of_twits: this.maxNumberOfTwits,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-thread-creation/`, twitterData);
                if (response.status === 200) {
                    this.twitterCreado = true;
                    this.showToast('Twitter en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('thread');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear el Twitter', 'error');
            }
        },
        canSubmitGuion() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            // and that at least 1 general instruction is filled
            if (
                (this.guionLinks.some(link => link !== '') || this.guionTextos.some(texto => texto !== ''))
                && this.guionGeneralInstructions.length > 0
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createGuion() {
            if (!this.canSubmitGuion()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción', 'error');
                return;
            }

            const guionData = {
                use_links: this.guionDesdeLinks,
                link_sources: this.guionLinks,
                link_sources_instructions: this.guionLinksInstructions,
                use_texts: this.guionDesdeTextos,
                text_sources: this.guionTextos,
                text_sources_instructions: this.guionTextosInstructions,
                general_instructions: this.guionGeneralInstructions,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-script-creation/`, guionData);
                if (response.status === 200) {
                    this.guionCreado = true;
                    this.showToast('Guion en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('script');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear el guion', 'error');
            }
        },
        canSubmitCorrection() {
            // Check that at least 1 text and 1 instruction is filled and not empty
            if (
                this.correctionTextos.some(texto => texto !== '')
                && this.correctionGeneralInstructions.length > 0
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createCorrection() {
            if (!this.canSubmitCorrection()) {
                this.showToast('Por favor completar al menos 1 texto y al menos 1 instrucción', 'error');
                return;
            }

            const correctionData = {
                use_texts: this.correctionDesdeTextos,
                text_sources: this.correctionTextos,
                text_sources_instructions: this.correctionTextosInstructions,
                general_instructions: this.correctionGeneralInstructions,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-correction-creation/`, correctionData);
                if (response.status === 200) {
                    this.correctionCreado = true;
                    this.showToast('Corrección en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('correction');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear la corrección', 'error');
            }
        },
        canSubmitTitulos() {
            // Check that at least 1 link or text and 1 instruction is filled and not empty
            // and that at least 1 general instruction is filled
            if (
                (this.titulosLinks.some(link => link !== '') || this.titulosTextos.some(texto => texto !== ''))
                && this.titulosGeneralInstructions.length > 0 && this.titulosCantidad > 0 && this.titulosCantidad < 11
            ) {
                console.log("True");
                return true;
            }
            return false;
        },
        async createTitulos() {
            if (!this.canSubmitTitulos()) {
                this.showToast('Por favor completar al menos 1 link o texto y al menos 1 instrucción, y seleccionar entre 1 y 10 títulos en cantidad', 'error');
                return;
            }

            const titulosData = {
                use_links: this.titulosDesdeLinks,
                link_sources: this.titulosLinks,
                link_sources_instructions: this.titulosLinksInstructions,
                use_texts: this.titulosDesdeTextos,
                text_sources: this.titulosTextos,
                text_sources_instructions: this.titulosTextosInstructions,
                general_instructions: this.titulosGeneralInstructions,
                cantidad: this.titulosCantidad,
            };

            try {
                const response = await axios.post(`${process.env.VUE_APP_BASE_URL}/api/v2/redaccion/request-titles-creation/`, titulosData);
                if (response.status === 200) {
                    this.titulosCreado = true;
                    this.showToast('Títulos en proceso de creación', 'success');

                    this.articleId = response.data._id;
                    this.articleStatus = 'pending';
                    this.lastUpdated = new Date().toLocaleString();

                    this.startPolling('titles');
                }
            } catch (error) {
                console.error(error);
                this.showToast('Error al crear los títulos', 'error');
            }
        },
        cleanReinterpretations() {
            this.reinterpretarDesdeLink = false;
            this.reinterpretarDesdeTexto = false;
            this.reinterpretarLinks = [''];
            this.reinterpretarTextos = [''];
            this.reinterpretarLinksInstrucciones = [];
            this.reinterpretarTextosInstrucciones = [];
            this.reinterpretarCreado = false;
            this.reinterpretarLoading = false;
            this.reinterpretarLinkResults = [];
            this.reinterpretarTextsResults = [];
        },
        cleanEditorials() {
            this.editorialGeneralInstructions = '';
            this.editorialDesdeLinks = false;
            this.editorialDesdeTextos = false;
            this.editorialLineaDesdeChatPTS = false;
            this.editorialLineaDesdeLinks = false;
            this.editorialLineaLinks = [''];
            this.editorialLinks = [''];
            this.editorialTextos = [''];
            this.editorialLinksInstructions = [];
            this.editorialTextosInstructions = [];
            this.editorialCreado = false;
            this.editorialLoading = false;
            this.editorialResult = null;
        },
        cleanPlacas() {
            this.placasGeneralInstructions = '';
            this.placasDesdeLinks = false;
            this.placasDesdeTextos = false;
            this.placasLinks = [''];
            this.placasTextos = [''];
            this.placasCreado = false;
            this.placasLoading = false;
            this.placasResult = null;
        },
        cleanTwitter() {
            this.twitterGeneralInstructions = '';
            this.twitterDesdeLinks = false;
            this.twitterDesdeTextos = false;
            this.twitterLinks = [''];
            this.twitterTextos = [''];
            this.twitterCreado = false;
            this.twitterLoading = false;
            this.twitterResult = null;
        },
        cleanGuion() {
            this.guionGeneralInstructions = '';
            this.guionDesdeLinks = false;
            this.guionDesdeTextos = false;
            this.guionLinks = [''];
            this.guionTextos = [''];
            this.guionCreado = false;
            this.guionLoading = false;
            this.guionResult = null;
        },
        cleanCorrection() {
            this.correctionGeneralInstructions = '';
            this.correctionDesdeTextos = false;
            this.correctionTextos = [''];
            this.correctionCreado = false;
            this.correctionLoading = false;
            this.correctionResult = null;
        },
        cleanTitulos() {
            this.titulosGeneralInstructions = '';
            this.titulosDesdeLinks = false;
            this.titulosDesdeTextos = false;
            this.titulosLinks = [''];
            this.titulosTextos = [''];
            this.titulosCreado = false;
            this.titulosLoading = false;
            this.titulosResultTitulos = null;
            this.titulosResultBajada = null;
            this.titulosCantidad = 3;
        },
    }
}
</script>
<style scoped>
.redaccion-tool-component {
    min-width: 600px;
    height: 100%;
    background-color: rgba(50, 50, 50, 0.9);
    border-radius: 0 0 8px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #333333;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
}

.tool-header {
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 48px;
    color: #fff;
}

.tool-header.tabs {
    justify-content: flex-start;
}

.tool-header select,
.tool-header option {
    font-size: 14pt;
}

.nota-input-container {
    width: 100%;
    overflow-y: scroll;
    padding-bottom: 96px;
    flex-grow: 1;
}

.option-container {
    width: 100%;
    padding: 24px 48px;
    color: #fff;
    overflow-y: scroll;
    padding-bottom: 96px;
}

.option-container h6.hint {
    text-align: center;
    font-size: 13pt;
    font-weight: 300;
    border: 2px solid #818181;
    margin: 0 48px;
    border-radius: 12px;
    padding: 6px 6px;
    max-width: 100%;
}

.fuentes-externas,
.fuentes-archivos {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    padding: 24px 0;
    margin-right: 24px;
}

.fuentes-externas>*,
.fuentes-archivos>* {
    margin-right: 48px;
}

.fuentes-externas-list,
.fuentes-archivos-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 24px;
    padding-bottom: 24px;
}

.fuentes-externas-list button,
.fuentes-archivos-list button {
    background-color: #333333;
    color: #fff;
    border: 2px solid #fff;
    padding: 6px 12px;
    cursor: pointer;
    flex-shrink: 0;
}

.fuentes-externas-row,
.fuentes-archivos-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;
}

.fuentes-externas h3,
.fuentes-archivos h3 {
    margin-bottom: 24px;
    font-size: 14pt;
}

.fuentes-externas-row label,
.fuentes-archivos-row label {
    margin-right: 12px;
    font-size: 12pt;
    flex-shrink: 0;
}

.fuentes-externas-row input,
.fuentes-externas-row textarea,
.fuentes-archivos-row input {
    margin-right: 12px;
    min-width: 200px;
    font-size: 12pt;
    flex-grow: 1;
    flex-shrink: 1;
    width: 100%;
}

.fuentes-externas-row textarea {
    min-height: 150px;
}


.instrucciones-generales {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    padding: 24px 0;
}

.instrucciones-generales .column {
    max-width: 240px;
    flex-grow: 0;
}

.urls-fuentes-externas,
.urls-fuentes-archivos {
    width: 50%;
}

.urls-fuentes-externas .row {
    margin-bottom: 12px;
    font-size: 14pt;
}

.instrucciones-generales .column ion-icon,
.urls-fuentes-externas ion-icon {
    font-size: 12pt;
    margin-right: 6px;
    position: relative;
    bottom: -2px;
}

.instrucciones-generales .column h6,
.urls-fuentes-externas h6,
.instrucciones-fuentes-externas h6,
.urls-fuentes-archivos h6,
.instrucciones-fuentes-archivos h6,
.fuentes-propias h6,
.otras-opciones h6 {
    font-weight: normal;
    font-size: 11pt;
    margin-top: 12px;
}

.urls-fuentes-externas h6,
.instrucciones-fuentes-externas h6,
.urls-fuentes-archivos h6,
.instrucciones-fuentes-archivos h6 {
    margin-top: 0;
    margin-bottom: 24px;
}

.fuentes-propias h6 {
    margin-bottom: 24px;
}

.instrucciones-generales textarea {
    font-size: 12pt;
    color: #333333;
    padding: 12px;
    margin-left: 24px;
    width: 100%;
}

.otras-opciones {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    padding: 24px 0;
}

.otras-opciones .column {
    max-width: 250px;
    margin-right: 24px;
}

.otras-opciones h3 {
    margin-right: 24px;
    font-size: 14pt;
}


.otras-opciones-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.otras-opciones-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.otras-opciones-row.no-shrink {
    flex-shrink: 0;
}

.otras-opciones-row label {
    margin-right: 12px;
    font-size: 12pt;
}

.otras-opciones-row input[type="text"],
.otras-opciones-row input[type="url"] {
    margin-right: 12px;
    font-size: 12pt;
    padding: 6px;
    min-width: 400px;
}

.row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}

.row:first-child {
    margin-right: 24px;
}

.field {
    margin-bottom: 12px;
}

.field label {
    font-weight: bold;
    margin-right: 8px;
    color: #fff;
    font-size: 13pt;
}

.field input {
    width: 100%;
    padding: 4px 12px;
    font-size: 12pt;
    border: none;
}

.field input:read-only {
    background-color: #ccc;
}

.tab-button {
    margin-right: 24px;
    cursor: pointer;
}

.tab-button:hover {
    color: rgb(173, 78, 101);
    border-bottom: 2px solid rgb(173, 78, 101);
}

.tab-button.selected {
    color: rgb(173, 78, 101);
    border-bottom: 2px solid rgb(173, 78, 101);
    background-color: rgba(173, 78, 101, 0.1);

}

.row>* {
    margin-right: 24px;
}

.row>.column {
    display: flex;
    flex-direction: column;
    width: 50%;
}

.tab {
    padding: 24px;
    height: 100%;
}

.tab>div {
    height: 100%;
}

#columna-cuerpo {
    width: 75%;
    flex-grow: 1;
    flex-shrink: 0;
    height: 100%;
}

#columna-cuerpo textarea {
    height: 100%;
    width: 100%;
    padding: 12px;
    font-size: 12pt;
    color: #333333;
}

.row.unica {
    height: 100%;
    align-items: flex-start;
}

.tab.output {
    width: 100%;
}

.tab.output input,
.tab.output textarea {
    width: 100%;
    padding: 12px;
    font-size: 12pt;
}

.tab.output textarea {
    min-height: 400px;
}

.tab.output label {
    position: sticky;
    top: 12px;
    background: #333333;
    padding: 6px 12px;
    margin-bottom: 12px;
}

.cargando {
    font-size: 24pt;
    color: #fff;
    padding: 24px;
    text-align: center;
}

.field.row {
    width: 100%;
}

.field.row label {
    margin-right: 24px;
}

.field.row textarea {
    flex-grow: 1;
    font-size: 12pt;
    min-height: 75px;
}

.primary {
    background-color: #ad4e65;
    color: #fff;
    padding: 12px 48px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14pt;
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
}

.primary:hover {
    background-color: #8c3a4b;
}

.secondary {
    background-color: #333333;
    color: #fff;
    padding: 12px 48px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14pt;
    margin-right: 24px;
    margin-left: auto;
    margin-right: auto;
}

.after-created {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    margin-left: 24px;
    margin-right: auto;
}

.pending-status {
    margin-left: 24px;
    font-size: 14pt;
    font-weight: bold;
}

.download-response {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 24px;
    font-size: 14pt;
}

.downloaded-article {
    min-height: 400px;
    width: 100%;
    padding: 12px;
    font-size: 12pt;
}

.error-message {
    min-height: 100px;
    width: 100%;
    padding: 12px;
    font-size: 12pt;
    color: red;
}

.pdf-response {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 24px;
    font-size: 14pt;
}

.parsed-body {
    min-height: 400px;
    width: 100%;
    padding: 12px;
    font-size: 12pt;
}

.slider-controls {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    background-color: #ad4e65;
    padding: 8px 24px;
    position: sticky;
    top: 0;
    z-index: 100;
    width: 100%;
}

.slider-controls h2 span {
    font-size: 14pt;
}


.slider-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.slider-buttons button {
    background-color: #333333;
    color: #fff;
    padding: 8px 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14pt;
    margin-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
}

.slider-buttons button:hover {
    transform: scale(1.05);
}


.slider-buttons button.primary {
    background-color: #ad4e65;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
    margin-top: 0;
}


slider-buttons button ion-icon {
    font-size: 15pt;
    margin: 0 8px;
}

.slide-indicator {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.slide-indicator div {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #333333;
    margin: 0 6px;
}

.slide-indicator div.active {
    background-color: #fff;
    width: 15px;
    height: 15px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
}

.modo-options {
    width: 100%;
    padding: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.modo-options button {
    background-color: #333333;
    color: #fff;
    padding: 48px;
    border-radius: 48px;
    border: none;
    cursor: pointer;
    font-size: 14pt;
    margin-right: 24px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16pt;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.1);
}

.modo-options button:hover {
    background-color: #ad4e65;
}


.modo-options button ion-icon {
    font-size: 40pt;
    margin-bottom: 12px
}

.option-container.modo-reinterpretar {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px;
    color: #fff;
    overflow-y: scroll;
    min-height: 80%;
}



.option-container.modo-reinterpretar .cols {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    position: relative;
    width: 100%;
    min-height: 80%;
    overflow-y: scroll;
    padding-bottom: 128px;
    flex-grow: 1;
}

.option-container.modo-reinterpretar .cols>div {
    flex-grow: 1;
    flex-shrink: 0;
}

.option-container.modo-reinterpretar .slider-controls h2 {
    margin-bottom: 0;
}


.col-izq,
.col-med,
.col-der,
.col-errors {
    max-width: calc(100vw - 900px);
}

.col-izq,
.col-med,
.col-der {

    margin-right: 24px;
}

.col-med,
.col-der,
.col-errors {
    margin-left: 24px;
}


.option-container.modo-reinterpretar h2 {
    margin-bottom: 24px;
    border-bottom: 1px solid #fff;
    align-self: center;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.option-container.modo-reinterpretar h2 button {
    background-color: #333333;
    color: #fff;
    padding: 12px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-size: 18pt;
    margin-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
    margin-left: 24px;
}

.option-container.modo-reinterpretar h2 button:hover {
    transform: scale(1.05);
    background-color: #ad4e65;
}



.option-container.modo-reinterpretar .row {
    margin-bottom: 12px;
}

.option-container.modo-reinterpretar h3 {
    margin-bottom: 12px;
    margin-top: 24px;
}


.option-container.modo-reinterpretar .row label {
    margin-right: 24px;
    color: #fff;
    font-weight: 600;
    font-size: 14pt;
}

.option-container.modo-reinterpretar .row input,
.option-container.modo-reinterpretar .row textarea {
    font-size: 12pt;
    padding: 12px;
    width: 100%;
}


.option-container.modo-reinterpretar .row button {
    background-color: #333333;
    color: #fff;
    padding: 12px 24px;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-size: 14pt;
    margin-right: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
    font-weight: 400;
}

.option-container.modo-reinterpretar .row button:hover {
    transform: scale(1.05);
    background-color: #ad4e65;
}



.col-der {
    flex-grow: 3;
}


.option-container.modo-reinterpretar div.buttons-carrusel button:not(:last-child) {
    margin-right: 24px;
}


.resultado textarea,
.resultados textarea,
textarea.general-instructions,
.placas-general-prompt {
    min-height: 200px;
    width: 100%;
    padding: 12px;
    font-size: 12pt;

}

textarea.general-instructions {
    min-height: 75px;
}

textarea.error {
    border: 2px solid #8c3a4b;
    min-height: 200px;
    width: 100%;
    padding: 12px;
    background-color: transparent;
    color: #fff;
}

.cerrada {
    background-color: #222;
    max-width: 100px;
    min-height: 400px;
    overflow: hidden;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.cerrada:hover {
    background-color: #111;
}


.cerrada h2 {
    transform: rotate(-90deg);
    border-bottom: none !important;
    margin-bottom: 0 !important;
}

.option-container.modo-reinterpretar h6 {
    font-weight: normal;
    font-size: 13pt;
    margin-top: 6px;
    margin-bottom: 0;
    color: #ccc;
}

.option-container.modo-reinterpretar .row-h6 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 24px;
}
</style>